/** This file is generated from clean-figma-tokens.js and pulls directly from Figma
 * Please do not edit values here directly!
 */

export const colorTokens = [
    {
        name: "aqua--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--300, #28A98F)",
            "ursa-dark": "var(--smar--com--color--teal--300, #28A98F)",
        },
    },
    {
        name: "aqua--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--50, #B5F2E6)",
            "ursa-dark": "var(--smar--com--color--teal--50, #B5F2E6)",
        },
    },
    {
        name: "aqua--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--100, #5AD3BB)",
            "ursa-dark": "var(--smar--com--color--teal--100, #5AD3BB)",
        },
    },
    {
        name: "aqua--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--75, #86E4D1)",
            "ursa-dark": "var(--smar--com--color--teal--75, #86E4D1)",
        },
    },
    {
        name: "aqua--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--400, #1C826D)",
            "ursa-dark": "var(--smar--com--color--teal--400, #1C826D)",
        },
    },
    {
        name: "aqua--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--800, #042A23)",
            "ursa-dark": "var(--smar--com--color--teal--800, #042A23)",
        },
    },
    {
        name: "aqua--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--600, #0F6151)",
            "ursa-dark": "var(--smar--com--color--teal--600, #0F6151)",
        },
    },
    {
        name: "azure--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--azure--400, #157E9D)",
            "ursa-dark": "var(--smar--com--color--azure--400, #157E9D)",
        },
    },
    {
        name: "azure--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--azure--75, #98DCF1)",
            "ursa-dark": "var(--smar--com--color--azure--75, #98DCF1)",
        },
    },
    {
        name: "azure--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--azure--200, #3AB9DF)",
            "ursa-dark": "var(--smar--com--color--azure--200, #3AB9DF)",
        },
    },
    {
        name: "azure--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--azure--100, #6ACAE7)",
            "ursa-dark": "var(--smar--com--color--azure--100, #6ACAE7)",
        },
    },
    {
        name: "azure--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--azure--400, #157E9D)",
            "ursa-dark": "var(--smar--com--color--azure--400, #157E9D)",
        },
    },
    {
        name: "azure--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--azure--800, #022A36)",
            "ursa-dark": "var(--smar--com--color--azure--800, #022A36)",
        },
    },
    {
        name: "azure--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--azure--700, #064355)",
            "ursa-dark": "var(--smar--com--color--azure--700, #064355)",
        },
    },
    {
        name: "blue--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--300, #6692FA)",
            "ursa-dark": "var(--smar--com--color--blue--300, #6692FA)",
        },
    },
    {
        name: "blue--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--50, #DBE6FF)",
            "ursa-dark": "var(--smar--com--color--blue--50, #DBE6FF)",
        },
    },
    {
        name: "blue--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--100, #9EBBFF)",
            "ursa-dark": "var(--smar--com--color--blue--100, #9EBBFF)",
        },
    },
    {
        name: "blue--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--75, #B8CDFF)",
            "ursa-dark": "var(--smar--com--color--blue--75, #B8CDFF)",
        },
    },
    {
        name: "blue--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--400, #3A6FE9)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "blue--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--800, #031C59)",
            "ursa-dark": "var(--smar--com--color--blue--800, #031C59)",
        },
    },
    {
        name: "blue--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "color--background--ai-icon-wrapper--default",
        description:
            "The default background for icons used in the AI Panel Experiences. Do not use this token outside of that surface.",
        value: {
            "lodestar-light": "#f5f5fd",
            "ursa-light": "var(--smar--com--color--indigo--35, #F5F0FF)",
            "ursa-dark": "var(--smar--com--color--indigo--400, #8959E8)",
        },
    },
    {
        name: "color--background--destructive--default",
        description: "The default version of destructive background colors.",
        value: {
            "lodestar-light": "#d03340",
            "ursa-light": "var(--smar--com--color--red--500, #CE1723)",
            "ursa-dark": "var(--smar--com--color--red--500, #CE1723)",
        },
    },
    {
        name: "color--background--destructive--strong",
        description: "The strong version of destructive background colors.",
        value: {
            "lodestar-light": "#a62833",
            "ursa-light": "var(--smar--com--color--red--600, #AB0D17)",
            "ursa-dark": "var(--smar--com--color--red--400, #DF2A36)",
        },
    },
    {
        name: "color--background--destructive--stronger",
        description: "The stronger version of destructive background colors.",
        value: {
            "lodestar-light": "#7c1e26",
            "ursa-light": "var(--smar--com--color--red--700, #7F050D)",
            "ursa-dark": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "color--background--destructive--strongest",
        description: "The strongest version of destructive background colors.",
        value: {
            "lodestar-light": "#531419",
            "ursa-light": "var(--smar--com--color--red--800, #570006)",
            "ursa-dark": "var(--smar--com--color--red--200, #F29298)",
        },
    },
    {
        name: "color--background--destructive--weak",
        description: "The weak version of destructive background colors.",
        value: {
            "lodestar-light": "#db656f",
            "ursa-light": "var(--smar--com--color--red--100, #F7ABB0)",
            "ursa-dark": "var(--smar--com--color--red--600, #AB0D17)",
        },
    },
    {
        name: "color--background--destructive--weaker",
        description: "The weaker version of destructive background colors.",
        value: {
            "lodestar-light": "#e4969c",
            "ursa-light": "var(--smar--com--color--red--75, #FBC6C9)",
            "ursa-dark": "var(--smar--com--color--red--700, #7F050D)",
        },
    },
    {
        name: "color--background--destructive--weakest",
        description: "The weakest version of destructive background colors.",
        value: {
            "lodestar-light": "#efc8cb",
            "ursa-light": "var(--smar--com--color--red--50, #FFE0E3)",
            "ursa-dark": "var(--smar--com--color--red--800, #570006)",
        },
    },
    {
        name: "color--background--error--default",
        description: "The default version of a background color to indicate an error.",
        value: {
            "lodestar-light": "#d14424",
            "ursa-light": "var(--smar--com--color--red--300, #E96D75)",
            "ursa-dark": "var(--smar--com--color--red--25, #FFF5F6)",
        },
    },
    {
        name: "color--background--error--weak",
        description: "The weak version of a background color to indicate an error.",
        value: {
            "lodestar-light": "#ffe0d7",
            "ursa-light": "var(--smar--com--color--red--75, #FBC6C9)",
            "ursa-dark": "var(--smar--com--color--red--60, #FED7DA)",
        },
    },
    {
        name: "color--background--error--weaker",
        description: "The weaker version of a background color to indicate an error.",
        value: {
            "lodestar-light": "#fff3ef",
            "ursa-light": "var(--smar--com--color--red--25, #FFF5F6)",
            "ursa-dark": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "color--background--info--default",
        description: "The default version of a background color to indicate info.",
        value: {
            "lodestar-light": "#007cc5",
            "ursa-light": "var(--smar--com--color--azure--400, #157E9D)",
            "ursa-dark": "var(--smar--com--color--azure--25, #EBFAFF)",
        },
    },
    {
        name: "color--background--info--weak",
        description: "The weak version of a background color to indicate info.",
        value: {
            "lodestar-light": "#a7c1e4",
            "ursa-light": "var(--smar--com--color--azure--50, #C6EFFA)",
            "ursa-dark": "var(--smar--com--color--azure--60, #B6E8F7)",
        },
    },
    {
        name: "color--background--info--weaker",
        description: "The weaker version of a background color to indicate info.",
        value: {
            "lodestar-light": "#d8e4fa",
            "ursa-light": "var(--smar--com--color--azure--25, #EBFAFF)",
            "ursa-dark": "var(--smar--com--color--azure--400, #157E9D)",
        },
    },
    {
        name: "color--background--neutral--default",
        description: "The default version of neutral background colors.",
        value: {
            "lodestar-light": "#e0e0e0",
            "ursa-light": "var(--smar--com--color--neutral--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--neutral--400, #6B7394)",
        },
    },
    {
        name: "color--background--neutral--strong",
        description: "The strong version of neutral background colors.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--neutral--100, #B8BDD1)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #878DAB)",
        },
    },
    {
        name: "color--background--neutral--stronger",
        description: "The stronger version of neutral background colors.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--neutral--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--neutral--200, #A6ACC4)",
        },
    },
    {
        name: "color--background--neutral--strongest",
        description: "The strongest version of neutral background colors.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--neutral--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--neutral--100, #B8BDD1)",
        },
    },
    {
        name: "color--background--neutral--weak",
        description: "The weak version of neutral background colors.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--neutral--60, #DCDEEA)",
            "ursa-dark": "var(--smar--com--color--neutral--500, #5F6786)",
        },
    },
    {
        name: "color--background--neutral--weaker",
        description: "The weaker version of neutral background colors.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--neutral--50, #E5E7F0)",
            "ursa-dark": "var(--smar--com--color--neutral--600, #4C5470)",
        },
    },
    {
        name: "color--background--neutral--weakest",
        description: "The weakest version of neutral background colors.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--neutral--35, #EEF0F6)",
            "ursa-dark": "var(--smar--com--color--neutral--700, #363C54)",
        },
    },
    {
        name: "color--background--neutral-inverse--default",
        description: "The default version of neutral inverse background colors.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--neutral--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--neutral--600, #4C5470)",
        },
    },
    {
        name: "color--background--neutral-inverse--strong",
        description: "The strong version of neutral inverse background colors.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--neutral--700, #363C54)",
            "ursa-dark": "var(--smar--com--color--neutral--700, #363C54)",
        },
    },
    {
        name: "color--background--neutral-inverse--stronger",
        description: "The stronger version of neutral inverse background colors.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--neutral--800, #212536)",
            "ursa-dark": "var(--smar--com--color--neutral--800, #212536)",
        },
    },
    {
        name: "color--background--neutral-inverse--strongest",
        description: "The strongest version of neutral inverse background colors.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--neutral--900, #11131D)",
            "ursa-dark": "var(--smar--com--color--neutral--900, #11131D)",
        },
    },
    {
        name: "color--background--neutral-inverse--weak",
        description: "The weak version of neutral inverse background colors.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--neutral--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--neutral--500, #5F6786)",
        },
    },
    {
        name: "color--background--neutral-inverse--weaker",
        description: "The weaker version of neutral inverse background colors.",
        value: {
            "lodestar-light": "#e0e0e0",
            "ursa-light": "var(--smar--com--color--neutral--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #878DAB)",
        },
    },
    {
        name: "color--background--neutral-inverse--weakest",
        description: "The weakest version of neutral inverse background colors.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--neutral--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--neutral--200, #A6ACC4)",
        },
    },
    {
        name: "color--background--notifications--default",
        description: "The weak version of backgrounds for notifications.",
        value: {
            "lodestar-light": "#d14424",
            "ursa-light": "var(--smar--com--color--orange--300, #F06B51)",
            "ursa-dark": "var(--smar--com--color--orange--400, #D64529)",
        },
    },
    {
        name: "color--background--notifications--weak",
        description: "The weak version of backgrounds for notifications.",
        value: {
            "lodestar-light": "#007cc5",
            "ursa-light": "var(--smar--com--color--slate--400, #6B7394)",
            "ursa-dark": "var(--smar--com--color--slate--500, #5F6786)",
        },
    },
    {
        name: "color--background--primary--default",
        description: "The default version of primary background colors.",
        value: {
            "lodestar-light": "#5996d6",
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "color--background--primary--strong",
        description: "The strong version of primary background colors.",
        value: {
            "lodestar-light": "#007cc5",
            "ursa-light": "var(--smar--com--color--blue--600, #184BC3)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "color--background--primary--stronger",
        description: "The stronger version of primary background colors.",
        value: {
            "lodestar-light": "#004173",
            "ursa-light": "var(--smar--com--color--blue--700, #0D3491)",
            "ursa-dark": "var(--smar--com--color--blue--300, #6692FA)",
        },
    },
    {
        name: "color--background--primary--strongest",
        description: "The strongest version of primary background colors.",
        value: {
            "lodestar-light": "#002847",
            "ursa-light": "var(--smar--com--color--blue--800, #031C59)",
            "ursa-dark": "var(--smar--com--color--blue--200, #80A6FF)",
        },
    },
    {
        name: "color--background--primary--weak",
        description: "The weak version of primary background colors.",
        value: {
            "lodestar-light": "#a7c1e4",
            "ursa-light": "var(--smar--com--color--blue--100, #9EBBFF)",
            "ursa-dark": "var(--smar--com--color--blue--600, #184BC3)",
        },
    },
    {
        name: "color--background--primary--weaker",
        description: "The weaker version of primary background colors.",
        value: {
            "lodestar-light": "#d8e4fa",
            "ursa-light": "var(--smar--com--color--blue--75, #B8CDFF)",
            "ursa-dark": "var(--smar--com--color--blue--700, #0D3491)",
        },
    },
    {
        name: "color--background--primary--weakest",
        description: "The weakest version of primary background colors.",
        value: {
            "lodestar-light": "#f0f5fd",
            "ursa-light": "var(--smar--com--color--blue--50, #DBE6FF)",
            "ursa-dark": "var(--smar--com--color--blue--800, #031C59)",
        },
    },
    {
        name: "color--background--slate--default",
        description: "The default version of slate background colors.",
        value: {
            "lodestar-light": "#e0e0e0",
            "ursa-light": "var(--smar--com--color--slate--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--background--neutral--default, #6B7394)",
        },
    },
    {
        name: "color--background--slate--strong",
        description: "The strong version of slate background colors.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--slate--100, #B8BDD1)",
            "ursa-dark": "var(--smar--com--color--background--neutral--strong, #878DAB)",
        },
    },
    {
        name: "color--background--slate--stronger",
        description: "The stronger version of slate background colors.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--slate--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--background--neutral--stronger, #A6ACC4)",
        },
    },
    {
        name: "color--background--slate--strongest",
        description: "The strongest version of slate background colors.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--slate--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--background--neutral--strongest, #B8BDD1)",
        },
    },
    {
        name: "color--background--slate--weak",
        description: "The weak version of slate background colors.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--slate--60, #DCDEEA)",
            "ursa-dark": "var(--smar--com--color--background--neutral--weak, #5F6786)",
        },
    },
    {
        name: "color--background--slate--weaker",
        description: "The weaker version of slate background colors.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--slate--50, #E5E7F0)",
            "ursa-dark": "var(--smar--com--color--background--neutral--weaker, #4C5470)",
        },
    },
    {
        name: "color--background--slate--weakest",
        description: "The weakest version of slate background colors.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--slate--35, #EEF0F6)",
            "ursa-dark": "var(--smar--com--color--background--neutral--weakest, #363C54)",
        },
    },
    {
        name: "color--background--slate-inverse--default",
        description: "The default version of slate inverse background colors.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--slate--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--slate--600, #4C5470)",
        },
    },
    {
        name: "color--background--slate-inverse--strong",
        description: "The strong version of slate inverse background colors.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--slate--700, #363C54)",
            "ursa-dark": "var(--smar--com--color--slate--700, #363C54)",
        },
    },
    {
        name: "color--background--slate-inverse--stronger",
        description: "The stronger version of slate inverse background colors.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--slate--800, #212536)",
            "ursa-dark": "var(--smar--com--color--slate--800, #212536)",
        },
    },
    {
        name: "color--background--slate-inverse--strongest",
        description: "The strongest version of slate inverse background colors.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--slate--900, #11131D)",
            "ursa-dark": "var(--smar--com--color--slate--900, #11131D)",
        },
    },
    {
        name: "color--background--slate-inverse--weak",
        description: "The weak version of slate inverse background colors.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--slate--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--slate--500, #5F6786)",
        },
    },
    {
        name: "color--background--slate-inverse--weaker",
        description: "The weaker version of slate inverse background colors.",
        value: {
            "lodestar-light": "#e0e0e0",
            "ursa-light": "var(--smar--com--color--slate--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--slate--300, #878DAB)",
        },
    },
    {
        name: "color--background--slate-inverse--weakest",
        description: "The weakest version of slate inverse background colors.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--slate--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--slate--200, #A6ACC4)",
        },
    },
    {
        name: "color--background--spectrum-aqua--default",
        description:
            "The default version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#4eaa9b",
            "ursa-light": "var(--smar--com--color--aqua--300, #28A98F)",
            "ursa-dark": "var(--smar--com--color--aqua--75, #86E4D1)",
        },
    },
    {
        name: "color--background--spectrum-aqua--strong",
        description:
            "The strong version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#008476",
            "ursa-light": "var(--smar--com--color--aqua--400, #1C826D)",
            "ursa-dark": "var(--smar--com--color--aqua--60, #9CECDC)",
        },
    },
    {
        name: "color--background--spectrum-aqua--stronger",
        description:
            "The stronger version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004e43",
            "ursa-light": "var(--smar--com--color--aqua--500, #167461)",
            "ursa-dark": "var(--smar--com--color--aqua--50, #B5F2E6)",
        },
    },
    {
        name: "color--background--spectrum-aqua--strongest",
        description:
            "The strongest version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#002923",
            "ursa-light": "var(--smar--com--color--aqua--600, #0F6151)",
            "ursa-dark": "var(--smar--com--color--aqua--25, #E8FDF9)",
        },
    },
    {
        name: "color--background--spectrum-aqua--weak",
        description:
            "The weak version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#a1c9c2",
            "ursa-light": "var(--smar--com--color--aqua--200, #30C0A3)",
            "ursa-dark": "var(--smar--com--color--aqua--100, #5AD3BB)",
        },
    },
    {
        name: "color--background--spectrum-aqua--weaker",
        description:
            "The weaker version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#dceae7",
            "ursa-light": "var(--smar--com--color--aqua--100, #5AD3BB)",
            "ursa-dark": "var(--smar--com--color--aqua--200, #30C0A3)",
        },
    },
    {
        name: "color--background--spectrum-aqua--weakest",
        description:
            "The weakest version of spectrum aqua for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f1f7f6",
            "ursa-light": "var(--smar--com--color--aqua--75, #86E4D1)",
            "ursa-dark": "var(--smar--com--color--aqua--300, #28A98F)",
        },
    },
    {
        name: "color--background--spectrum-azure--default",
        description:
            "The default version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#5996d6",
            "ursa-light": "var(--smar--com--color--azure--300, #1EA0C8)",
            "ursa-dark": "var(--smar--com--color--azure--75, #98DCF1)",
        },
    },
    {
        name: "color--background--spectrum-azure--strong",
        description:
            "The strong version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#007cc5",
            "ursa-light": "var(--smar--com--color--azure--500, #10718E)",
            "ursa-dark": "var(--smar--com--color--azure--60, #B6E8F7)",
        },
    },
    {
        name: "color--background--spectrum-azure--stronger",
        description:
            "The stronger version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004173",
            "ursa-light": "var(--smar--com--color--azure--600, #0B5C75)",
            "ursa-dark": "var(--smar--com--color--azure--50, #C6EFFA)",
        },
    },
    {
        name: "color--background--spectrum-azure--strongest",
        description:
            "The strongest version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#002847",
            "ursa-light": "var(--smar--com--color--azure--700, #064355)",
            "ursa-dark": "var(--smar--com--color--azure--25, #EBFAFF)",
        },
    },
    {
        name: "color--background--spectrum-azure--weak",
        description:
            "The weak version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#a7c1e4",
            "ursa-light": "var(--smar--com--color--azure--200, #3AB9DF)",
            "ursa-dark": "var(--smar--com--color--azure--100, #6ACAE7)",
        },
    },
    {
        name: "color--background--spectrum-azure--weaker",
        description:
            "The weaker version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#d8e4fa",
            "ursa-light": "var(--smar--com--color--azure--100, #6ACAE7)",
            "ursa-dark": "var(--smar--com--color--azure--200, #3AB9DF)",
        },
    },
    {
        name: "color--background--spectrum-azure--weakest",
        description:
            "The weakest version of spectrum azure for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f0f5fd",
            "ursa-light": "var(--smar--com--color--azure--75, #98DCF1)",
            "ursa-dark": "var(--smar--com--color--azure--300, #1EA0C8)",
        },
    },
    {
        name: "color--background--spectrum-blue--default",
        description:
            "The default version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#5996d6",
            "ursa-light": "var(--smar--com--color--blue--300, #6692FA)",
            "ursa-dark": "var(--smar--com--color--blue--75, #B8CDFF)",
        },
    },
    {
        name: "color--background--spectrum-blue--strong",
        description:
            "The strong version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#007cc5",
            "ursa-light": "var(--smar--com--color--blue--400, #3A6FE9)",
            "ursa-dark": "var(--smar--com--color--blue--60, #C7D8FF)",
        },
    },
    {
        name: "color--background--spectrum-blue--stronger",
        description:
            "The stronger version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004173",
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--50, #DBE6FF)",
        },
    },
    {
        name: "color--background--spectrum-blue--strongest",
        description:
            "The strongest version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#002847",
            "ursa-light": "var(--smar--com--color--blue--600, #184BC3)",
            "ursa-dark": "var(--smar--com--color--blue--25, #F5F8FF)",
        },
    },
    {
        name: "color--background--spectrum-blue--weak",
        description:
            "The weak version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#a7c1e4",
            "ursa-light": "var(--smar--com--color--blue--200, #80A6FF)",
            "ursa-dark": "var(--smar--com--color--blue--100, #9EBBFF)",
        },
    },
    {
        name: "color--background--spectrum-blue--weaker",
        description:
            "The weaker version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#d8e4fa",
            "ursa-light": "var(--smar--com--color--blue--100, #9EBBFF)",
            "ursa-dark": "var(--smar--com--color--blue--200, #80A6FF)",
        },
    },
    {
        name: "color--background--spectrum-blue--weakest",
        description:
            "The weakest version of spectrum blue for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f0f5fd",
            "ursa-light": "var(--smar--com--color--blue--75, #B8CDFF)",
            "ursa-dark": "var(--smar--com--color--blue--300, #6692FA)",
        },
    },
    {
        name: "color--background--spectrum-gold--default",
        description:
            "The default version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e18502",
            "ursa-light": "var(--smar--com--color--gold--300, #BF8E1D)",
            "ursa-dark": "var(--smar--com--color--gold--60, #FBDA8D)",
        },
    },
    {
        name: "color--background--spectrum-gold--strong",
        description:
            "The strong version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#ab6600",
            "ursa-light": "var(--smar--com--color--gold--400, #966E13)",
            "ursa-dark": "var(--smar--com--color--gold--50, #FDE6AF)",
        },
    },
    {
        name: "color--background--spectrum-gold--stronger",
        description:
            "The stronger version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#653300",
            "ursa-light": "var(--smar--com--color--gold--500, #88620C)",
            "ursa-dark": "var(--smar--com--color--gold--35, #FFF0CC)",
        },
    },
    {
        name: "color--background--spectrum-gold--strongest",
        description:
            "The strongest version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#492400",
            "ursa-light": "var(--smar--com--color--gold--600, #705006)",
            "ursa-dark": "var(--smar--com--color--gold--25, #FFF6E0)",
        },
    },
    {
        name: "color--background--spectrum-gold--weak",
        description:
            "The weak version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#ffb761",
            "ursa-light": "var(--smar--com--color--gold--200, #DEA41B)",
            "ursa-dark": "var(--smar--com--color--gold--75, #F9CD67)",
        },
    },
    {
        name: "color--background--spectrum-gold--weaker",
        description:
            "The weaker version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#fee3c0",
            "ursa-light": "var(--smar--com--color--gold--100, #EFB32A)",
            "ursa-dark": "var(--smar--com--color--gold--100, #EFB32A)",
        },
    },
    {
        name: "color--background--spectrum-gold--weakest",
        description:
            "The weakest version of spectrum gold for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#fff4e6",
            "ursa-light": "var(--smar--com--color--gold--75, #F9CD67)",
            "ursa-dark": "var(--smar--com--color--gold--200, #DEA41B)",
        },
    },
    {
        name: "color--background--spectrum-green--default",
        description:
            "The default version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#70a13c",
            "ursa-light": "var(--smar--com--color--green--300, #29AE40)",
            "ursa-dark": "var(--smar--com--color--green--75, #8EE69D)",
        },
    },
    {
        name: "color--background--spectrum-green--strong",
        description:
            "The strong version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#488306",
            "ursa-light": "var(--smar--com--color--green--400, #1D862F)",
            "ursa-dark": "var(--smar--com--color--green--60, #A1EDAD)",
        },
    },
    {
        name: "color--background--spectrum-green--stronger",
        description:
            "The stronger version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#275600",
            "ursa-light": "var(--smar--com--color--green--500, #177827)",
            "ursa-dark": "var(--smar--com--color--green--50, #B9F4C3)",
        },
    },
    {
        name: "color--background--spectrum-green--strongest",
        description:
            "The strongest version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#193700",
            "ursa-light": "var(--smar--com--color--green--600, #0F621C)",
            "ursa-dark": "var(--smar--com--color--green--25, #E7FDEB)",
        },
    },
    {
        name: "color--background--spectrum-green--weak",
        description:
            "The weak version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#b2c997",
            "ursa-light": "var(--smar--com--color--green--200, #32C84C)",
            "ursa-dark": "var(--smar--com--color--green--100, #62D574)",
        },
    },
    {
        name: "color--background--spectrum-green--weaker",
        description:
            "The weaker version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e1ebd6",
            "ursa-light": "var(--smar--com--color--green--100, #62D574)",
            "ursa-dark": "var(--smar--com--color--green--200, #32C84C)",
        },
    },
    {
        name: "color--background--spectrum-green--weakest",
        description:
            "The weakest version of spectrum green for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f3f7ef",
            "ursa-light": "var(--smar--com--color--green--75, #8EE69D)",
            "ursa-dark": "var(--smar--com--color--green--300, #29AE40)",
        },
    },
    {
        name: "color--background--spectrum-indigo--default",
        description:
            "The default version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#848be9",
            "ursa-light": "var(--smar--com--color--indigo--300, #A87EFB)",
            "ursa-dark": "var(--smar--com--color--indigo--75, #D6C2FF)",
        },
    },
    {
        name: "color--background--spectrum-indigo--strong",
        description:
            "The strong version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#566ae3",
            "ursa-light": "var(--smar--com--color--indigo--400, #8959E8)",
            "ursa-dark": "var(--smar--com--color--indigo--60, #E0D1FF)",
        },
    },
    {
        name: "color--background--spectrum-indigo--stronger",
        description:
            "The stronger version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c3491",
            "ursa-light": "var(--smar--com--color--indigo--500, #7847DC)",
            "ursa-dark": "var(--smar--com--color--indigo--50, #EBE0FF)",
        },
    },
    {
        name: "color--background--spectrum-indigo--strongest",
        description:
            "The strongest version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c245b",
            "ursa-light": "var(--smar--com--color--indigo--600, #6329D6)",
            "ursa-dark": "var(--smar--com--color--indigo--25, #F8F5FF)",
        },
    },
    {
        name: "color--background--spectrum-indigo--weak",
        description:
            "The weak version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#bab8f1",
            "ursa-light": "var(--smar--com--color--indigo--200, #BB99FF)",
            "ursa-dark": "var(--smar--com--color--indigo--100, #C9ADFF)",
        },
    },
    {
        name: "color--background--spectrum-indigo--weaker",
        description:
            "The weaker version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e6e5fa",
            "ursa-light": "var(--smar--com--color--indigo--100, #C9ADFF)",
            "ursa-dark": "var(--smar--com--color--indigo--200, #BB99FF)",
        },
    },
    {
        name: "color--background--spectrum-indigo--weakest",
        description:
            "The weakest version of spectrum indigo for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f5f5fd",
            "ursa-light": "var(--smar--com--color--indigo--75, #D6C2FF)",
            "ursa-dark": "var(--smar--com--color--indigo--300, #A87EFB)",
        },
    },
    {
        name: "color--background--spectrum-mint--default",
        description:
            "The default version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#01af6a",
            "ursa-light": "var(--smar--com--color--mint--300, #29AE40)",
            "ursa-dark": "var(--smar--com--color--mint--75, #8EE69D)",
        },
    },
    {
        name: "color--background--spectrum-mint--strong",
        description:
            "The strong version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#008c54",
            "ursa-light": "var(--smar--com--color--mint--400, #1D862F)",
            "ursa-dark": "var(--smar--com--color--mint--60, #A1EDAD)",
        },
    },
    {
        name: "color--background--spectrum-mint--stronger",
        description:
            "The stronger version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#00693f",
            "ursa-light": "var(--smar--com--color--mint--500, #177827)",
            "ursa-dark": "var(--smar--com--color--mint--35, #D2F9D8)",
        },
    },
    {
        name: "color--background--spectrum-mint--strongest",
        description:
            "The strongest version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#00462a",
            "ursa-light": "var(--smar--com--color--mint--600, #0F621C)",
            "ursa-dark": "var(--smar--com--color--mint--25, #E7FDEB)",
        },
    },
    {
        name: "color--background--spectrum-mint--weak",
        description:
            "The weak version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#40c28f",
            "ursa-light": "var(--smar--com--color--mint--200, #32C84C)",
            "ursa-dark": "var(--smar--com--color--mint--100, #62D574)",
        },
    },
    {
        name: "color--background--spectrum-mint--weaker",
        description:
            "The weaker version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#7dd4b1",
            "ursa-light": "var(--smar--com--color--mint--100, #62D574)",
            "ursa-dark": "var(--smar--com--color--mint--200, #32C84C)",
        },
    },
    {
        name: "color--background--spectrum-mint--weakest",
        description:
            "The weakest version of spectrum mint for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#bbe7d6",
            "ursa-light": "var(--smar--com--color--mint--75, #8EE69D)",
            "ursa-dark": "var(--smar--com--color--mint--300, #29AE40)",
        },
    },
    {
        name: "color--background--spectrum-neutral--default",
        description:
            "The default version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--neutral--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--neutral--75, #D0D3E2)",
        },
    },
    {
        name: "color--background--spectrum-neutral--strong",
        description:
            "The strong version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--neutral--400, #6B7394)",
            "ursa-dark": "var(--smar--com--color--neutral--60, #DCDEEA)",
        },
    },
    {
        name: "color--background--spectrum-neutral--stronger",
        description:
            "The stronger version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--neutral--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--neutral--50, #E5E7F0)",
        },
    },
    {
        name: "color--background--spectrum-neutral--strongest",
        description:
            "The strongest version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--neutral--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--neutral--25, #F5F6FA)",
        },
    },
    {
        name: "color--background--spectrum-neutral--weak",
        description:
            "The weak version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e0e0e0",
            "ursa-light": "var(--smar--com--color--neutral--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--neutral--100, #B8BDD1)",
        },
    },
    {
        name: "color--background--spectrum-neutral--weaker",
        description:
            "The weaker version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--neutral--100, #B8BDD1)",
            "ursa-dark": "var(--smar--com--color--neutral--200, #A6ACC4)",
        },
    },
    {
        name: "color--background--spectrum-neutral--weakest",
        description:
            "The weakest version of spectrum neutral for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--neutral--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #878DAB)",
        },
    },
    {
        name: "color--background--spectrum-orange--default",
        description:
            "The default version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e18502",
            "ursa-light": "var(--smar--com--color--orange--300, #F06B51)",
            "ursa-dark": "var(--smar--com--color--orange--75, #FEC8BE)",
        },
    },
    {
        name: "color--background--spectrum-orange--strong",
        description:
            "The strong version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#ab6600",
            "ursa-light": "var(--smar--com--color--orange--500, #B84028)",
            "ursa-dark": "var(--smar--com--color--orange--60, #FED5CD)",
        },
    },
    {
        name: "color--background--spectrum-orange--stronger",
        description:
            "The stronger version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#653300",
            "ursa-light": "var(--smar--com--color--orange--600, #973421)",
            "ursa-dark": "var(--smar--com--color--orange--50, #FFE1DC)",
        },
    },
    {
        name: "color--background--spectrum-orange--strongest",
        description:
            "The strongest version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#492400",
            "ursa-light": "var(--smar--com--color--orange--700, #732111)",
            "ursa-dark": "var(--smar--com--color--orange--35, #FFEEEB)",
        },
    },
    {
        name: "color--background--spectrum-orange--weak",
        description:
            "The weak version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#ffb761",
            "ursa-light": "var(--smar--com--color--orange--200, #FB8F79)",
            "ursa-dark": "var(--smar--com--color--orange--100, #FDA796)",
        },
    },
    {
        name: "color--background--spectrum-orange--weaker",
        description:
            "The weaker version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#fee3c0",
            "ursa-light": "var(--smar--com--color--orange--100, #FDA796)",
            "ursa-dark": "var(--smar--com--color--orange--200, #FB8F79)",
        },
    },
    {
        name: "color--background--spectrum-orange--weakest",
        description:
            "The weakest version of spectrum orange for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#fff4e6",
            "ursa-light": "var(--smar--com--color--orange--75, #FEC8BE)",
            "ursa-dark": "var(--smar--com--color--orange--300, #F06B51)",
        },
    },
    {
        name: "color--background--spectrum-orchid--default",
        description:
            "The default version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#c76ca1",
            "ursa-light": "var(--smar--com--color--orchid--300, #CE73DE)",
            "ursa-dark": "var(--smar--com--color--orchid--75, #F0C3F8)",
        },
    },
    {
        name: "color--background--spectrum-orchid--strong",
        description:
            "The strong version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#b94d90",
            "ursa-light": "var(--smar--com--color--orchid--400, #B53DCC)",
            "ursa-dark": "var(--smar--com--color--orchid--60, #F5D0FB)",
        },
    },
    {
        name: "color--background--spectrum-orchid--stronger",
        description:
            "The stronger version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#8b2066",
            "ursa-light": "var(--smar--com--color--orchid--500, #A531B9)",
            "ursa-dark": "var(--smar--com--color--orchid--50, #F8DDFD)",
        },
    },
    {
        name: "color--background--spectrum-orchid--strongest",
        description:
            "The strongest version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#610e44",
            "ursa-light": "var(--smar--com--color--orchid--600, #8B259D)",
            "ursa-dark": "var(--smar--com--color--orchid--25, #FDF5FF)",
        },
    },
    {
        name: "color--background--spectrum-orchid--weak",
        description:
            "The weak version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e5b8d1",
            "ursa-light": "var(--smar--com--color--orchid--200, #DB91E8)",
            "ursa-dark": "var(--smar--com--color--orchid--100, #E5A7F1)",
        },
    },
    {
        name: "color--background--spectrum-orchid--weaker",
        description:
            "The weaker version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f5e1ec",
            "ursa-light": "var(--smar--com--color--orchid--100, #E5A7F1)",
            "ursa-dark": "var(--smar--com--color--orchid--200, #DB91E8)",
        },
    },
    {
        name: "color--background--spectrum-orchid--weakest",
        description:
            "The weakest version of spectrum orchid for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#fbf3f8",
            "ursa-light": "var(--smar--com--color--orchid--75, #F0C3F8)",
            "ursa-dark": "var(--smar--com--color--orchid--300, #CE73DE)",
        },
    },
    {
        name: "color--background--spectrum-pink--default",
        description:
            "The default version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#c76ca1",
            "ursa-light": "var(--smar--com--color--pink--300, #E76AB3)",
            "ursa-dark": "var(--smar--com--color--pink--75, #FDC4E4)",
        },
    },
    {
        name: "color--background--spectrum-pink--strong",
        description:
            "The strong version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#b94d90",
            "ursa-light": "var(--smar--com--color--pink--400, #CE3B91)",
            "ursa-dark": "var(--smar--com--color--pink--60, #FDD3EC)",
        },
    },
    {
        name: "color--background--spectrum-pink--stronger",
        description:
            "The stronger version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#8b2066",
            "ursa-light": "var(--smar--com--color--pink--500, #B53680)",
            "ursa-dark": "var(--smar--com--color--pink--50, #FEE1F2)",
        },
    },
    {
        name: "color--background--spectrum-pink--strongest",
        description:
            "The strongest version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#610e44",
            "ursa-light": "var(--smar--com--color--pink--600, #992468)",
            "ursa-dark": "var(--smar--com--color--pink--25, #FFF5FA)",
        },
    },
    {
        name: "color--background--spectrum-pink--weak",
        description:
            "The weak version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e5b8d1",
            "ursa-light": "var(--smar--com--color--pink--200, #F589C8)",
            "ursa-dark": "var(--smar--com--color--pink--100, #F9A4D6)",
        },
    },
    {
        name: "color--background--spectrum-pink--weaker",
        description:
            "The weaker version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f5e1ec",
            "ursa-light": "var(--smar--com--color--pink--100, #F9A4D6)",
            "ursa-dark": "var(--smar--com--color--pink--200, #F589C8)",
        },
    },
    {
        name: "color--background--spectrum-pink--weakest",
        description:
            "The weakest version of spectrum pink for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#fbf3f8",
            "ursa-light": "var(--smar--com--color--pink--75, #FDC4E4)",
            "ursa-dark": "var(--smar--com--color--pink--300, #E76AB3)",
        },
    },
    {
        name: "color--background--spectrum-red--default",
        description:
            "The default version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#ee6f4c",
            "ursa-light": "var(--smar--com--color--red--300, #E96D75)",
            "ursa-dark": "var(--smar--com--color--red--75, #FBC6C9)",
        },
    },
    {
        name: "color--background--spectrum-red--strong",
        description:
            "The strong version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#d14424",
            "ursa-light": "var(--smar--com--color--red--400, #DF2A36)",
            "ursa-dark": "var(--smar--com--color--red--60, #FED7DA)",
        },
    },
    {
        name: "color--background--spectrum-red--stronger",
        description:
            "The stronger version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#9d0c00",
            "ursa-light": "var(--smar--com--color--red--500, #CE1723)",
            "ursa-dark": "var(--smar--com--color--red--50, #FFE0E3)",
        },
    },
    {
        name: "color--background--spectrum-red--strongest",
        description:
            "The strongest version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#6d0800",
            "ursa-light": "var(--smar--com--color--red--600, #AB0D17)",
            "ursa-dark": "var(--smar--com--color--red--25, #FFF5F6)",
        },
    },
    {
        name: "color--background--spectrum-red--weak",
        description:
            "The weak version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f6b09d",
            "ursa-light": "var(--smar--com--color--red--200, #F29298)",
            "ursa-dark": "var(--smar--com--color--red--100, #F7ABB0)",
        },
    },
    {
        name: "color--background--spectrum-red--weaker",
        description:
            "The weaker version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#ffe0d7",
            "ursa-light": "var(--smar--com--color--red--100, #F7ABB0)",
            "ursa-dark": "var(--smar--com--color--red--200, #F29298)",
        },
    },
    {
        name: "color--background--spectrum-red--weakest",
        description:
            "The weakest version of spectrum red for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#fff3ef",
            "ursa-light": "var(--smar--com--color--red--75, #FBC6C9)",
            "ursa-dark": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "color--background--spectrum-rose--default",
        description:
            "The default version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#c76ca1",
            "ursa-light": "var(--smar--com--color--rose--300, #E76AB3)",
            "ursa-dark": "var(--smar--com--color--rose--75, #FDC4E4)",
        },
    },
    {
        name: "color--background--spectrum-rose--strong",
        description:
            "The strong version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#b94d90",
            "ursa-light": "var(--smar--com--color--rose--400, #CE3B91)",
            "ursa-dark": "var(--smar--com--color--rose--60, #FDD3EC)",
        },
    },
    {
        name: "color--background--spectrum-rose--stronger",
        description:
            "The stronger version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#8b2066",
            "ursa-light": "var(--smar--com--color--rose--500, #B53680)",
            "ursa-dark": "var(--smar--com--color--rose--50, #FEE1F2)",
        },
    },
    {
        name: "color--background--spectrum-rose--strongest",
        description:
            "The strongest version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#610e44",
            "ursa-light": "var(--smar--com--color--rose--600, #992468)",
            "ursa-dark": "var(--smar--com--color--rose--25, #FFF5FA)",
        },
    },
    {
        name: "color--background--spectrum-rose--weak",
        description:
            "The weak version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e5b8d1",
            "ursa-light": "var(--smar--com--color--rose--200, #F589C8)",
            "ursa-dark": "var(--smar--com--color--rose--100, #F9A4D6)",
        },
    },
    {
        name: "color--background--spectrum-rose--weaker",
        description:
            "The weaker version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f5e1ec",
            "ursa-light": "var(--smar--com--color--rose--100, #F9A4D6)",
            "ursa-dark": "var(--smar--com--color--rose--300, #E76AB3)",
        },
    },
    {
        name: "color--background--spectrum-rose--weakest",
        description:
            "The weakest version of spectrum rose for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#fbf3f8",
            "ursa-light": "var(--smar--com--color--rose--75, #FDC4E4)",
            "ursa-dark": "var(--smar--com--color--rose--300, #E76AB3)",
        },
    },
    {
        name: "color--background--spectrum-slate--default",
        description:
            "The default version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--slate--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--slate--75, #D0D3E2)",
        },
    },
    {
        name: "color--background--spectrum-slate--strong",
        description:
            "The strong version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--slate--400, #6B7394)",
            "ursa-dark": "var(--smar--com--color--slate--60, #DCDEEA)",
        },
    },
    {
        name: "color--background--spectrum-slate--stronger",
        description:
            "The stronger version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--slate--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--slate--50, #E5E7F0)",
        },
    },
    {
        name: "color--background--spectrum-slate--strongest",
        description:
            "The strongest version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--slate--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--slate--25, #F5F6FA)",
        },
    },
    {
        name: "color--background--spectrum-slate--weak",
        description:
            "The weak version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e0e0e0",
            "ursa-light": "var(--smar--com--color--slate--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--slate--100, #B8BDD1)",
        },
    },
    {
        name: "color--background--spectrum-slate--weaker",
        description:
            "The weaker version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--slate--100, #B8BDD1)",
            "ursa-dark": "var(--smar--com--color--slate--200, #A6ACC4)",
        },
    },
    {
        name: "color--background--spectrum-slate--weakest",
        description:
            "The weakest version of spectrum slate for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--slate--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--slate--300, #878DAB)",
        },
    },
    {
        name: "color--background--spectrum-teal--default",
        description:
            "The default version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#4eaa9b",
            "ursa-light": "var(--smar--com--color--teal--300, #28A98F)",
            "ursa-dark": "var(--smar--com--color--teal--75, #86E4D1)",
        },
    },
    {
        name: "color--background--spectrum-teal--strong",
        description:
            "The strong version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#008476",
            "ursa-light": "var(--smar--com--color--teal--400, #1C826D)",
            "ursa-dark": "var(--smar--com--color--teal--60, #9CECDC)",
        },
    },
    {
        name: "color--background--spectrum-teal--stronger",
        description:
            "The stronger version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004e43",
            "ursa-light": "var(--smar--com--color--teal--500, #167461)",
            "ursa-dark": "var(--smar--com--color--teal--50, #B5F2E6)",
        },
    },
    {
        name: "color--background--spectrum-teal--strongest",
        description:
            "The strongest version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#002923",
            "ursa-light": "var(--smar--com--color--teal--600, #0F6151)",
            "ursa-dark": "var(--smar--com--color--teal--25, #E8FDF9)",
        },
    },
    {
        name: "color--background--spectrum-teal--weak",
        description:
            "The weak version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#a1c9c2",
            "ursa-light": "var(--smar--com--color--teal--200, #30C0A3)",
            "ursa-dark": "var(--smar--com--color--teal--100, #5AD3BB)",
        },
    },
    {
        name: "color--background--spectrum-teal--weaker",
        description:
            "The weaker version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#dceae7",
            "ursa-light": "var(--smar--com--color--teal--100, #5AD3BB)",
            "ursa-dark": "var(--smar--com--color--teal--200, #30C0A3)",
        },
    },
    {
        name: "color--background--spectrum-teal--weakest",
        description:
            "The weakest version of spectrum teal for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f1f7f6",
            "ursa-light": "var(--smar--com--color--teal--75, #86E4D1)",
            "ursa-dark": "var(--smar--com--color--teal--300, #28A98F)",
        },
    },
    {
        name: "color--background--spectrum-violet--default",
        description:
            "The default version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#848be9",
            "ursa-light": "var(--smar--com--color--violet--300, #A87EFB)",
            "ursa-dark": "var(--smar--com--color--violet--75, #D6C2FF)",
        },
    },
    {
        name: "color--background--spectrum-violet--strong",
        description:
            "The strong version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#566ae3",
            "ursa-light": "var(--smar--com--color--violet--400, #8959E8)",
            "ursa-dark": "var(--smar--com--color--violet--60, #E0D1FF)",
        },
    },
    {
        name: "color--background--spectrum-violet--stronger",
        description:
            "The stronger version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c3491",
            "ursa-light": "var(--smar--com--color--violet--500, #7847DC)",
            "ursa-dark": "var(--smar--com--color--violet--50, #EBE0FF)",
        },
    },
    {
        name: "color--background--spectrum-violet--strongest",
        description:
            "The strongest version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c245b",
            "ursa-light": "var(--smar--com--color--violet--600, #6329D6)",
            "ursa-dark": "var(--smar--com--color--violet--25, #F8F5FF)",
        },
    },
    {
        name: "color--background--spectrum-violet--weak",
        description:
            "The weak version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#bab8f1",
            "ursa-light": "var(--smar--com--color--violet--200, #BB99FF)",
            "ursa-dark": "var(--smar--com--color--violet--100, #C9ADFF)",
        },
    },
    {
        name: "color--background--spectrum-violet--weaker",
        description:
            "The weaker version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e6e5fa",
            "ursa-light": "var(--smar--com--color--violet--100, #C9ADFF)",
            "ursa-dark": "var(--smar--com--color--violet--200, #BB99FF)",
        },
    },
    {
        name: "color--background--spectrum-violet--weakest",
        description:
            "The weakest version of spectrum violet for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f5f5fd",
            "ursa-light": "var(--smar--com--color--violet--75, #D6C2FF)",
            "ursa-dark": "var(--smar--com--color--violet--300, #A87EFB)",
        },
    },
    {
        name: "color--background--spectrum-yellow--default",
        description:
            "The default version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e6a907",
            "ursa-light": "var(--smar--com--color--yellow--300, #BF8E1D)",
            "ursa-dark": "var(--smar--com--color--yellow--60, #FBDA8D)",
        },
    },
    {
        name: "color--background--spectrum-yellow--strong",
        description:
            "The strong version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#996f00",
            "ursa-light": "var(--smar--com--color--yellow--500, #88620C)",
            "ursa-dark": "var(--smar--com--color--yellow--50, #FDE6AF)",
        },
    },
    {
        name: "color--background--spectrum-yellow--stronger",
        description:
            "The stronger version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#5a4000",
            "ursa-light": "var(--smar--com--color--yellow--600, #705006)",
            "ursa-dark": "var(--smar--com--color--yellow--35, #FFF0CC)",
        },
    },
    {
        name: "color--background--spectrum-yellow--strongest",
        description:
            "The strongest version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#3d2c00",
            "ursa-light": "var(--smar--com--color--yellow--700, #543B03)",
            "ursa-dark": "var(--smar--com--color--yellow--25, #FFF6E0)",
        },
    },
    {
        name: "color--background--spectrum-yellow--weak",
        description:
            "The weak version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#f5cf6a",
            "ursa-light": "var(--smar--com--color--yellow--200, #DEA41B)",
            "ursa-dark": "var(--smar--com--color--yellow--75, #F9CD67)",
        },
    },
    {
        name: "color--background--spectrum-yellow--weaker",
        description:
            "The weaker version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#ffefc5",
            "ursa-light": "var(--smar--com--color--yellow--100, #EFB32A)",
            "ursa-dark": "var(--smar--com--color--yellow--100, #EFB32A)",
        },
    },
    {
        name: "color--background--spectrum-yellow--weakest",
        description:
            "The weakest version of spectrum yellow for background colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#fff8e7",
            "ursa-light": "var(--smar--com--color--yellow--75, #F9CD67)",
            "ursa-dark": "var(--smar--com--color--yellow--200, #DEA41B)",
        },
    },
    {
        name: "color--background--success--default",
        description: "The default version of a background color to indicate success.",
        value: {
            "lodestar-light": "#008c54",
            "ursa-light": "var(--smar--com--color--mint--300, #29AE40)",
            "ursa-dark": "var(--smar--com--color--mint--25, #E7FDEB)",
        },
    },
    {
        name: "color--background--success--weak",
        description: "The weak version of a background color to indicate success.",
        value: {
            "lodestar-light": "#7dd4b1",
            "ursa-light": "var(--smar--com--color--mint--50, #B9F4C3)",
            "ursa-dark": "var(--smar--com--color--mint--60, #A1EDAD)",
        },
    },
    {
        name: "color--background--success--weaker",
        description: "The weaker version of a background color to indicate success.",
        value: {
            "lodestar-light": "#bbe7d6",
            "ursa-light": "var(--smar--com--color--mint--25, #E7FDEB)",
            "ursa-dark": "var(--smar--com--color--mint--300, #29AE40)",
        },
    },
    {
        name: "color--background--surfaces--body",
        description: "The background color for the document body.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--neutral--00, #FFFFFF)",
            "ursa-dark": "var(--smar--com--color--neutral--900, #11131D)",
        },
    },
    {
        name: "color--background--surfaces--canvas",
        description: "The background color for the canvas surface.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--slate--25, #F5F6FA)",
            "ursa-dark": "var(--smar--com--color--neutral--900, #11131D)",
        },
    },
    {
        name: "color--background--surfaces--overlay",
        description: "The background color for the overlay.",
        value: { "lodestar-light": "rgba(0, 0, 0, 0.1)", "ursa-light": "#24273214", "ursa-dark": "#6B739480" },
    },
    {
        name: "color--background--surfaces--stage",
        description: "The background color for the stage surface.",
        value: {
            "lodestar-light": "#111111",
            "ursa-light": "var(--smar--com--color--neutral--700, #363C54)",
            "ursa-dark": "var(--smar--com--color--neutral--700, #363C54)",
        },
    },
    {
        name: "color--background--surfaces--work",
        description: "The background color the work surface.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--background--surfaces--body, #FFFFFF)",
            "ursa-dark": "var(--smar--com--color--neutral--800, #212536)",
        },
    },
    {
        name: "color--background--warning--default",
        description: "The default version of a background color to indicate a warning.",
        value: {
            "lodestar-light": "#cc9c31",
            "ursa-light": "var(--smar--com--color--gold--200, #DEA41B)",
            "ursa-dark": "var(--smar--com--color--gold--25, #FFF6E0)",
        },
    },
    {
        name: "color--background--warning--weak",
        description: "The weak version of a background color to indicate a warning.",
        value: {
            "lodestar-light": "#fcde9b",
            "ursa-light": "var(--smar--com--color--gold--50, #FDE6AF)",
            "ursa-dark": "var(--smar--com--color--gold--60, #FBDA8D)",
        },
    },
    {
        name: "color--background--warning--weaker",
        description: "The weaker version of a background color to indicate a warning.",
        value: {
            "lodestar-light": "#fbeccb",
            "ursa-light": "var(--smar--com--color--gold--25, #FFF6E0)",
            "ursa-dark": "var(--smar--com--color--gold--200, #DEA41B)",
        },
    },
    {
        name: "color--border--error--default",
        description: "The default border to indicate an error.",
        value: {
            "lodestar-light": "#d03340",
            "ursa-light": "var(--smar--com--color--red--500, #CE1723)",
            "ursa-dark": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "color--border--neutral--default",
        description: "The default neutral color border.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--neutral--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #878DAB)",
        },
    },
    {
        name: "color--border--neutral--strong",
        description: "The strong neutral color border.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--neutral--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--neutral--200, #A6ACC4)",
        },
    },
    {
        name: "color--border--neutral--stronger",
        description: "The stronger neutral color border.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--neutral--700, #363C54)",
            "ursa-dark": "var(--smar--com--color--neutral--100, #B8BDD1)",
        },
    },
    {
        name: "color--border--neutral--strongest",
        description: "The strongest neutral color border.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--neutral--900, #11131D)",
            "ursa-dark": "var(--smar--com--color--neutral--75, #D0D3E2)",
        },
    },
    {
        name: "color--border--neutral--weak",
        description: "The weak neutral color border.",
        value: {
            "lodestar-light": "#e0e0e0",
            "ursa-light": "var(--smar--com--color--neutral--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--neutral--400, #6B7394)",
        },
    },
    {
        name: "color--border--neutral--weaker",
        description: "The weaker neutral color border.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--neutral--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--neutral--500, #5F6786)",
        },
    },
    {
        name: "color--border--neutral--weakest",
        description: "The weakest neutral color border.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--neutral--50, #E5E7F0)",
            "ursa-dark": "var(--smar--com--color--neutral--700, #363C54)",
        },
    },
    {
        name: "color--border--primary--default",
        description: "The weakest primary color border.",
        value: {
            "lodestar-light": "#5996d6",
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--300, #6692FA)",
        },
    },
    {
        name: "color--border--primary--weak",
        description: "The weak primary color border.",
        value: {
            "lodestar-light": "#a7c1e4",
            "ursa-light": "var(--smar--com--color--blue--300, #6692FA)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "color--border--primary--weaker",
        description: "The weaker primary color border.",
        value: {
            "lodestar-light": "#d8e4fa",
            "ursa-light": "var(--smar--com--color--blue--100, #9EBBFF)",
            "ursa-dark": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "color--border--primary--weakest",
        description: "The weakest primary color border.",
        value: {
            "lodestar-light": "#f0f5fd",
            "ursa-light": "var(--smar--com--color--blue--75, #B8CDFF)",
            "ursa-dark": "var(--smar--com--color--blue--600, #184BC3)",
        },
    },
    {
        name: "color--border--slate--default",
        description: "The default slate color border.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--slate--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--border--neutral--default, #878DAB)",
        },
    },
    {
        name: "color--border--slate--strong",
        description: "The strong slate color border.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--slate--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--border--neutral--strong, #A6ACC4)",
        },
    },
    {
        name: "color--border--slate--stronger",
        description: "The stronger slate color border.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--slate--700, #363C54)",
            "ursa-dark": "var(--smar--com--color--border--neutral--stronger, #B8BDD1)",
        },
    },
    {
        name: "color--border--slate--strongest",
        description: "The strongest slate color border.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--slate--900, #11131D)",
            "ursa-dark": "var(--smar--com--color--border--neutral--strongest, #D0D3E2)",
        },
    },
    {
        name: "color--border--slate--weak",
        description: "The weak slate color border.",
        value: {
            "lodestar-light": "#e0e0e0",
            "ursa-light": "var(--smar--com--color--slate--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--border--neutral--weak, #6B7394)",
        },
    },
    {
        name: "color--border--slate--weaker",
        description: "The weaker slate color border.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--slate--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--border--neutral--weaker, #5F6786)",
        },
    },
    {
        name: "color--border--slate--weakest",
        description: "The weakest slate color border.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--slate--50, #E5E7F0)",
            "ursa-dark": "var(--smar--com--color--border--neutral--weakest, #363C54)",
        },
    },
    {
        name: "color--border--spectrum-aqua--default",
        description:
            "The border color for spectrum aqua. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004e43",
            "ursa-light": "var(--smar--com--color--aqua--600, #0F6151)",
            "ursa-dark": "var(--smar--com--color--aqua--300, #28A98F)",
        },
    },
    {
        name: "color--border--spectrum-azure--default",
        description:
            "The border color for spectrum azure. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004173",
            "ursa-light": "var(--smar--com--color--azure--600, #0B5C75)",
            "ursa-dark": "var(--smar--com--color--azure--300, #1EA0C8)",
        },
    },
    {
        name: "color--border--spectrum-blue--default",
        description:
            "The border color for spectrum blue. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004173",
            "ursa-light": "var(--smar--com--color--blue--600, #184BC3)",
            "ursa-dark": "var(--smar--com--color--blue--300, #6692FA)",
        },
    },
    {
        name: "color--border--spectrum-slate--default",
        description:
            "The border color for spectrum slate. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--slate--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--slate--300, #878DAB)",
        },
    },
    {
        name: "color--border--spectrum-gold--default",
        description:
            "The border color for spectrum gold. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#997525",
            "ursa-light": "var(--smar--com--color--gold--600, #705006)",
            "ursa-dark": "var(--smar--com--color--gold--300, #BF8E1D)",
        },
    },
    {
        name: "color--border--spectrum-green--default",
        description:
            "The border color for spectrum green. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#275600",
            "ursa-light": "var(--smar--com--color--green--600, #0F621C)",
            "ursa-dark": "var(--smar--com--color--green--300, #29AE40)",
        },
    },
    {
        name: "color--border--spectrum-indigo--default",
        description:
            "The border color for spectrum indigo. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c3491",
            "ursa-light": "var(--smar--com--color--indigo--600, #6329D6)",
            "ursa-dark": "var(--smar--com--color--indigo--300, #A87EFB)",
        },
    },
    {
        name: "color--border--spectrum-mint--default",
        description:
            "The border color for spectrum mint. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#00693f",
            "ursa-light": "var(--smar--com--color--mint--600, #0F621C)",
            "ursa-dark": "var(--smar--com--color--mint--300, #29AE40)",
        },
    },
    {
        name: "color--border--spectrum-neutral--default",
        description:
            "The border color for spectrum neutral. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--neutral--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #878DAB)",
        },
    },
    {
        name: "color--border--spectrum-orange--default",
        description:
            "The border color for spectrum orange. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#997525",
            "ursa-light": "var(--smar--com--color--orange--700, #732111)",
            "ursa-dark": "var(--smar--com--color--orange--300, #F06B51)",
        },
    },
    {
        name: "color--border--spectrum-orchid--default",
        description:
            "The border color for spectrum orchid. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#8b2066",
            "ursa-light": "var(--smar--com--color--orchid--600, #8B259D)",
            "ursa-dark": "var(--smar--com--color--orchid--300, #CE73DE)",
        },
    },
    {
        name: "color--border--spectrum-pink--default",
        description:
            "The border color for spectrum pink. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#8b2066",
            "ursa-light": "var(--smar--com--color--pink--600, #992468)",
            "ursa-dark": "var(--smar--com--color--pink--300, #E76AB3)",
        },
    },
    {
        name: "color--border--spectrum-red--default",
        description:
            "The border color for spectrum red. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#7c1e26",
            "ursa-light": "var(--smar--com--color--red--600, #AB0D17)",
            "ursa-dark": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "color--border--spectrum-rose--default",
        description:
            "The border color for spectrum rose. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#8b2066",
            "ursa-light": "var(--smar--com--color--rose--600, #992468)",
            "ursa-dark": "var(--smar--com--color--rose--300, #E76AB3)",
        },
    },
    {
        name: "color--border--spectrum-teal--default",
        description:
            "The border color for spectrum teal. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004e43",
            "ursa-light": "var(--smar--com--color--teal--600, #0F6151)",
            "ursa-dark": "var(--smar--com--color--teal--300, #28A98F)",
        },
    },
    {
        name: "color--border--spectrum-violet--default",
        description:
            "The border color for spectrum violet. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c3491",
            "ursa-light": "var(--smar--com--color--violet--600, #6329D6)",
            "ursa-dark": "var(--smar--com--color--violet--300, #A87EFB)",
        },
    },
    {
        name: "color--border--spectrum-yellow--default",
        description:
            "The border color for spectrum yellow. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#5a4000",
            "ursa-light": "var(--smar--com--color--yellow--600, #705006)",
            "ursa-dark": "var(--smar--com--color--yellow--300, #BF8E1D)",
        },
    },
    {
        name: "color--border--success--default",
        description: "The default border to indicate success.",
        value: {
            "lodestar-light": "#01af6a",
            "ursa-light": "var(--smar--com--color--mint--400, #1D862F)",
            "ursa-dark": "var(--smar--com--color--mint--300, #29AE40)",
        },
    },
    {
        name: "color--border--surfaces--body",
        description: "The border color that matches the document body.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--background--surfaces--body, #FFFFFF)",
            "ursa-dark": "var(--smar--com--color--background--surfaces--body, #11131D)",
        },
    },
    {
        name: "color--border--surfaces--canvas",
        description: "The border color that matches the canvas surface.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--background--surfaces--canvas, #F5F6FA)",
            "ursa-dark": "var(--smar--com--color--background--surfaces--canvas, #11131D)",
        },
    },
    {
        name: "color--border--surfaces--focus",
        description: "The border color for focus",
        value: {
            "lodestar-light": "#5996d6",
            "ursa-light": "var(--smar--com--color--blue--400, #3A6FE9)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "color--border--surfaces--stage",
        description: "The border color that matches the stage surface.",
        value: {
            "lodestar-light": "#111111",
            "ursa-light": "var(--smar--com--color--background--surfaces--stage, #363C54)",
            "ursa-dark": "var(--smar--com--color--background--surfaces--stage, #363C54)",
        },
    },
    {
        name: "color--border--surfaces--work",
        description: "The border color that matches the work surface.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--background--surfaces--body, #FFFFFF)",
            "ursa-dark": "var(--smar--com--color--background--surfaces--body, #11131D)",
        },
    },
    {
        name: "color--border--warning--default",
        description: "The default border to indicate a warning.",
        value: {
            "lodestar-light": "#ffc33e",
            "ursa-light": "var(--smar--com--color--gold--400, #966E13)",
            "ursa-dark": "var(--smar--com--color--gold--300, #BF8E1D)",
        },
    },
    {
        name: "color--icons--destructive--default",
        description: "The default version of destructive for icons.",
        value: {
            "lodestar-light": "#ee6f4c",
            "ursa-light": "var(--smar--com--color--red--400, #DF2A36)",
            "ursa-dark": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "color--icons--destructive--strong",
        description: "The strong version of destructive for icons.",
        value: {
            "lodestar-light": "#d14424",
            "ursa-light": "var(--smar--com--color--red--500, #CE1723)",
            "ursa-dark": "var(--smar--com--color--red--200, #F29298)",
        },
    },
    {
        name: "color--icons--destructive--stronger",
        description: "The stronger version of destructive for icons.",
        value: {
            "lodestar-light": "#9d0c00",
            "ursa-light": "var(--smar--com--color--red--600, #AB0D17)",
            "ursa-dark": "var(--smar--com--color--red--100, #F7ABB0)",
        },
    },
    {
        name: "color--icons--destructive--strongest",
        description: "The strongest version of destructive for icons.",
        value: {
            "lodestar-light": "#6d0800",
            "ursa-light": "var(--smar--com--color--red--800, #570006)",
            "ursa-dark": "var(--smar--com--color--red--75, #FBC6C9)",
        },
    },
    {
        name: "color--icons--destructive--weak",
        description: "The weak version of destructive for icons.",
        value: {
            "lodestar-light": "#f6b09d",
            "ursa-light": "var(--smar--com--color--red--300, #E96D75)",
            "ursa-dark": "var(--smar--com--color--red--400, #DF2A36)",
        },
    },
    {
        name: "color--icons--destructive--weaker",
        description: "The weaker version of destructive for icons.",
        value: {
            "lodestar-light": "#ffe0d7",
            "ursa-light": "var(--smar--com--color--red--200, #F29298)",
            "ursa-dark": "var(--smar--com--color--red--500, #CE1723)",
        },
    },
    {
        name: "color--icons--destructive--weakest",
        description: "The weakest version of destructive for icons.",
        value: {
            "lodestar-light": "#fff3ef",
            "ursa-light": "var(--smar--com--color--red--75, #FBC6C9)",
            "ursa-dark": "var(--smar--com--color--red--600, #AB0D17)",
        },
    },
    {
        name: "color--icons--destructive-inverse--stronger",
        description: "The stronger version of destructive inverse icons.",
        value: {
            "lodestar-light": "#fff3ef",
            "ursa-light": "var(--smar--com--color--red--25, #FFF5F6)",
            "ursa-dark": "var(--smar--com--color--red--25, #FFF5F6)",
        },
    },
    {
        name: "color--icons--error--default",
        description: "The default version of error icons. Used for icons that denote an error.",
        value: {
            "lodestar-light": "#7c1e26",
            "ursa-light": "var(--smar--com--color--red--500, #CE1723)",
            "ursa-dark": "var(--smar--com--color--red--500, #CE1723)",
        },
    },
    {
        name: "color--icons--error--weak",
        description: "The weak version of error icons. Used for icons that denote an error.",
        value: {
            "lodestar-light": "#d03340",
            "ursa-light": "var(--smar--com--color--red--200, #F29298)",
            "ursa-dark": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "color--icons--info--default",
        description: "The default version of info icons. Used for icons that denote information.",
        value: {
            "lodestar-light": "#004173",
            "ursa-light": "var(--smar--com--color--azure--600, #0B5C75)",
            "ursa-dark": "var(--smar--com--color--azure--600, #0B5C75)",
        },
    },
    {
        name: "color--icons--info--weak",
        description: "The weak version of info icons. Used for icons that denote information.",
        value: {
            "lodestar-light": "#007cc5",
            "ursa-light": "var(--smar--com--color--blue--200, #80A6FF)",
            "ursa-dark": "var(--smar--com--color--blue--200, #80A6FF)",
        },
    },
    {
        name: "color--icons--neutral--default",
        description: "The default version of neutral for icons.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--neutral--400, #6B7394)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #878DAB)",
        },
    },
    {
        name: "color--icons--neutral--strong",
        description: "The strong version of neutral for icons.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--neutral--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--neutral--200, #A6ACC4)",
        },
    },
    {
        name: "color--icons--neutral--stronger",
        description: "The stronger version of neutral for icons.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--neutral--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--neutral--100, #B8BDD1)",
        },
    },
    {
        name: "color--icons--neutral--strongest",
        description: "The strongest version of neutral for icons.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--neutral--800, #212536)",
            "ursa-dark": "var(--smar--com--color--neutral--75, #D0D3E2)",
        },
    },
    {
        name: "color--icons--neutral--weak",
        description: "The weak version of neutral for icons.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--neutral--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--neutral--400, #6B7394)",
        },
    },
    {
        name: "color--icons--neutral--weaker",
        description: "The weaker version of neutral for icons.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--neutral--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--neutral--500, #5F6786)",
        },
    },
    {
        name: "color--icons--neutral--weakest",
        description: "The weakest version of neutral for icons.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--neutral--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--neutral--600, #4C5470)",
        },
    },
    {
        name: "color--icons--neutral-inverse--default",
        description: "The default version of neutral inverse for icons.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--neutral--00, #FFFFFF)",
            "ursa-dark": "var(--smar--com--color--neutral--00, #FFFFFF)",
        },
    },
    {
        name: "color--icons--neutral-inverse--weak",
        description: "The weaker version of neutral inverse for icons.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--neutral--60, #DCDEEA)",
            "ursa-dark": "var(--smar--com--color--neutral--60, #DCDEEA)",
        },
    },
    {
        name: "color--icons--primary--default",
        description: "The default version of primary icons.",
        value: {
            "lodestar-light": "#5996d6",
            "ursa-light": "var(--smar--com--color--blue--400, #3A6FE9)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "color--icons--primary--strong",
        description: "The strong version of primary icons.",
        value: {
            "lodestar-light": "#007cc5",
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "color--icons--primary--stronger",
        description: "The stronger version of primary icons.",
        value: {
            "lodestar-light": "#004173",
            "ursa-light": "var(--smar--com--color--blue--600, #184BC3)",
            "ursa-dark": "var(--smar--com--color--blue--600, #184BC3)",
        },
    },
    {
        name: "color--icons--primary--strongest",
        description: "The strongest version of primary icons.",
        value: {
            "lodestar-light": "#002847",
            "ursa-light": "var(--smar--com--color--blue--800, #031C59)",
            "ursa-dark": "var(--smar--com--color--blue--800, #031C59)",
        },
    },
    {
        name: "color--icons--primary--weak",
        description: "The weak version of primary icons.",
        value: {
            "lodestar-light": "#a7c1e4",
            "ursa-light": "var(--smar--com--color--blue--300, #6692FA)",
            "ursa-dark": "var(--smar--com--color--blue--300, #6692FA)",
        },
    },
    {
        name: "color--icons--primary--weaker",
        description: "The weaker version of primary icons.",
        value: {
            "lodestar-light": "#d8e4fa",
            "ursa-light": "var(--smar--com--color--blue--200, #80A6FF)",
            "ursa-dark": "var(--smar--com--color--blue--200, #80A6FF)",
        },
    },
    {
        name: "color--icons--primary--weakest",
        description: "The weakest version of slate for icons.",
        value: {
            "lodestar-light": "#f0f5fd",
            "ursa-light": "var(--smar--com--color--blue--75, #B8CDFF)",
            "ursa-dark": "var(--smar--com--color--blue--75, #B8CDFF)",
        },
    },
    {
        name: "color--icons--primary-inverse--stronger",
        description: "The stronger version of primary inverse icons",
        value: {
            "lodestar-light": "#a7c1e4",
            "ursa-light": "var(--smar--com--color--blue--25, #F5F8FF)",
            "ursa-dark": "var(--smar--com--color--blue--25, #F5F8FF)",
        },
    },
    {
        name: "color--icons--slate--default",
        description: "The default version of slate for icons.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--slate--400, #6B7394)",
            "ursa-dark": "var(--smar--com--color--icons--neutral--default, #878DAB)",
        },
    },
    {
        name: "color--icons--slate--strong",
        description: "The strong version of slate for icons.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--slate--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--icons--neutral--strong, #A6ACC4)",
        },
    },
    {
        name: "color--icons--slate--stronger",
        description: "The stronger version of slate for icons.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--slate--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--icons--neutral--stronger, #B8BDD1)",
        },
    },
    {
        name: "color--icons--slate--strongest",
        description: "The strongest version of slate for icons.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--slate--900, #11131D)",
            "ursa-dark": "var(--smar--com--color--icons--neutral--strongest, #D0D3E2)",
        },
    },
    {
        name: "color--icons--slate--weak",
        description: "The weak version of slate for icons.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--slate--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--icons--neutral--weak, #6B7394)",
        },
    },
    {
        name: "color--icons--slate--weaker",
        description: "The weaker version of slate for icons.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--slate--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--icons--neutral--weaker, #5F6786)",
        },
    },
    {
        name: "color--icons--slate--weakest",
        description: "The weakest version of slate for icons.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--slate--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--icons--neutral--weakest, #4C5470)",
        },
    },
    {
        name: "color--icons--slate-inverse--default",
        description: "The default version of slate inverse for icons.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--neutral--00, #FFFFFF)",
            "ursa-dark": "var(--smar--com--color--neutral--00, #FFFFFF)",
        },
    },
    {
        name: "color--icons--slate-inverse--weak",
        description: "The weak version of slate inverse for icons.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--slate--60, #DCDEEA)",
            "ursa-dark": "var(--smar--com--color--slate--60, #DCDEEA)",
        },
    },
    {
        name: "color--icons--spectrum-aqua--default",
        description:
            "The default version of spectrum aqua for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004e43",
            "ursa-light": "var(--smar--com--color--text--spectrum-aqua--default, #042A23)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-aqua--default, #042A23)",
        },
    },
    {
        name: "color--icons--spectrum-azure--default",
        description:
            "The default version of spectrum azure for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#002847",
            "ursa-light": "var(--smar--com--color--text--spectrum-azure--default, #022A36)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-azure--default, #022A36)",
        },
    },
    {
        name: "color--icons--spectrum-blue--default",
        description:
            "The default version of spectrum blue for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#002847",
            "ursa-light": "var(--smar--com--color--text--spectrum-blue--default, #031C59)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-blue--default, #031C59)",
        },
    },
    {
        name: "color--icons--spectrum-gold--default",
        description:
            "The default version of spectrum gold for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#653300",
            "ursa-light": "var(--smar--com--color--text--spectrum-gold--default, #322301)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-gold--default, #322301)",
        },
    },
    {
        name: "color--icons--spectrum-green--default",
        description:
            "The default version of spectrum green for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#193700",
            "ursa-light": "var(--smar--com--color--text--spectrum-green--default, #042F0A)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-green--default, #042F0A)",
        },
    },
    {
        name: "color--icons--spectrum-indigo--default",
        description:
            "The default version of spectrum indigo for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c245b",
            "ursa-light": "var(--smar--com--color--text--spectrum-indigo--default, #26026E)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-indigo--default, #26026E)",
        },
    },
    {
        name: "color--icons--spectrum-indigo--weak",
        description:
            "The weak version of spectrum indigo for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#566ae3",
            "ursa-light": "var(--smar--com--color--indigo--500, #7847DC)",
            "ursa-dark": "var(--smar--com--color--indigo--500, #7847DC)",
        },
    },
    {
        name: "color--icons--spectrum-indigo--weaker",
        description:
            "The weaker version of spectrum indigo for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#bab8f1",
            "ursa-light": "var(--smar--com--color--indigo--300, #A87EFB)",
            "ursa-dark": "var(--smar--com--color--indigo--300, #A87EFB)",
        },
    },
    {
        name: "color--icons--spectrum-indigo--weakest",
        description:
            "The weakest version of spectrum indigo for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#e6e5fa",
            "ursa-light": "var(--smar--com--color--indigo--100, #C9ADFF)",
            "ursa-dark": "var(--smar--com--color--indigo--100, #C9ADFF)",
        },
    },
    {
        name: "color--icons--spectrum-mint--default",
        description:
            "The default version of spectrum mint for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#00462a",
            "ursa-light": "var(--smar--com--color--text--spectrum-mint--default, #042F0A)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-mint--default, #042F0A)",
        },
    },
    {
        name: "color--icons--spectrum-neutral--default",
        description:
            "The default version of spectrum neutral for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--text--neutral--strong, #212536)",
            "ursa-dark": "var(--smar--com--color--text--neutral--strong, #FFFFFF)",
        },
    },
    {
        name: "color--icons--spectrum-orange--default",
        description:
            "The default version of spectrum orange for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#653300",
            "ursa-light": "var(--smar--com--color--text--spectrum-orange--default, #4C1106)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-orange--default, #4C1106)",
        },
    },
    {
        name: "color--icons--spectrum-orchid--default",
        description:
            "The default version of spectrum orchid for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#610e44",
            "ursa-light": "var(--smar--com--color--text--spectrum-orchid--default, #41064B)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-orchid--default, #41064B)",
        },
    },
    {
        name: "color--icons--spectrum-pink--default",
        description:
            "The default version of spectrum pink for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#610e44",
            "ursa-light": "var(--smar--com--color--text--spectrum-pink--default, #4C062F)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-pink--default, #4C062F)",
        },
    },
    {
        name: "color--icons--spectrum-red--default",
        description:
            "The default version of spectrum red for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#6d0800",
            "ursa-light": "var(--smar--com--color--text--spectrum-red--default, #570006)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-red--default, #570006)",
        },
    },
    {
        name: "color--icons--spectrum-rose--default",
        description:
            "The default version of spectrum rose for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#610e44",
            "ursa-light": "var(--smar--com--color--text--spectrum-rose--default, #4C062F)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-rose--default, #4C062F)",
        },
    },
    {
        name: "color--icons--spectrum-slate--default",
        description:
            "The default version of spectrum slate for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--text--slate--strong, #212536)",
            "ursa-dark": "var(--smar--com--color--text--slate--strong)",
        },
    },
    {
        name: "color--icons--spectrum-teal--default",
        description:
            "The default version of spectrum teal for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004e43",
            "ursa-light": "var(--smar--com--color--text--spectrum-teal--default, #042A23)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-teal--default, #042A23)",
        },
    },
    {
        name: "color--icons--spectrum-violet--default",
        description:
            "The default version of spectrum violet for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c245b",
            "ursa-light": "var(--smar--com--color--text--spectrum-violet--default, #26026E)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-violet--default, #26026E)",
        },
    },
    {
        name: "color--icons--spectrum-yellow--default",
        description:
            "The default version of spectrum yellow for icon colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#5a4000",
            "ursa-light": "var(--smar--com--color--text--spectrum-yellow--default, #322301)",
            "ursa-dark": "var(--smar--com--color--text--spectrum-yellow--default, #322301)",
        },
    },
    {
        name: "color--icons--success--default",
        description: "The default version of success icons. Used for icons that denote success.",
        value: {
            "lodestar-light": "#00693f",
            "ursa-light": "var(--smar--com--color--green--500, #177827)",
            "ursa-dark": "var(--smar--com--color--mint--400, #1D862F)",
        },
    },
    {
        name: "color--icons--success--weak",
        description: "The weak version of success icons. Used for icons that denote success.",
        value: {
            "lodestar-light": "#008c54",
            "ursa-light": "var(--smar--com--color--green--200, #32C84C)",
            "ursa-dark": "var(--smar--com--color--mint--200, #32C84C)",
        },
    },
    {
        name: "color--icons--warning--default",
        description: "The default version of warning icons. Used for icons that denote information.",
        value: {
            "lodestar-light": "#997525",
            "ursa-light": "var(--smar--com--color--gold--500, #88620C)",
            "ursa-dark": "var(--smar--com--color--gold--500, #88620C)",
        },
    },
    {
        name: "color--icons--warning--weak",
        description: "The weak version of warning icons. Used for icons that denote information.",
        value: {
            "lodestar-light": "#ffc33e",
            "ursa-light": "var(--smar--com--color--gold--200, #DEA41B)",
            "ursa-dark": "var(--smar--com--color--gold--200, #DEA41B)",
        },
    },
    {
        name: "color--text--destructive--default",
        description: "The default version of destructive text colors.",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--500, #CE1723)",
            "ursa-dark": "var(--smar--com--color--red--100, #F7ABB0)",
        },
    },
    {
        name: "color--text--destructive--strong",
        description: "The strong version of destructive text colors.",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--600, #AB0D17)",
            "ursa-dark": "var(--smar--com--color--red--600, #AB0D17)",
        },
    },
    {
        name: "color--text--destructive--stronger",
        description: "The stronger version of destructive text colors.",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--700, #7F050D)",
            "ursa-dark": "var(--smar--com--color--red--700, #7F050D)",
        },
    },
    {
        name: "color--text--destructive--strongest",
        description: "The strongest version of destructive text colors.",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--900, #330003)",
            "ursa-dark": "var(--smar--com--color--red--900, #330003)",
        },
    },
    {
        name: "color--text--destructive--weak",
        description: "The weak version of destructive text colors.",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--75, #FBC6C9)",
            "ursa-dark": "var(--smar--com--color--red--75, #FBC6C9)",
        },
    },
    {
        name: "color--text--destructive--weaker",
        description: "The weaker version of destructive text colors.",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--60, #FED7DA)",
            "ursa-dark": "var(--smar--com--color--red--60, #FED7DA)",
        },
    },
    {
        name: "color--text--destructive--weakest",
        description: "The weakest version of warning text colors. Used on warning text.",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--25, #FFF5F6)",
            "ursa-dark": "var(--smar--com--color--red--25, #FFF5F6)",
        },
    },
    {
        name: "color--text--error--default",
        description: "The default version of error text colors. Used on error text.",
        value: {
            "lodestar-light": "#6d0800",
            "ursa-light": "var(--smar--com--color--red--800, #570006)",
            "ursa-dark": "var(--smar--com--color--red--200, #F29298)",
        },
    },
    {
        name: "color--text--error--weak",
        description: "The weak version of error text colors. Used on error text.",
        value: {
            "lodestar-light": "#9d0c00",
            "ursa-light": "var(--smar--com--color--red--500, #CE1723)",
            "ursa-dark": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "color--text--info--default",
        description: "The default version of info text colors. Used on info text.",
        value: {
            "lodestar-light": "#3f4952",
            "ursa-light": "var(--smar--com--color--azure--800, #022A36)",
            "ursa-dark": "var(--smar--com--color--azure--200, #3AB9DF)",
        },
    },
    {
        name: "color--text--info--weak",
        description: "The weak version of info text colors. Used on info text.",
        value: {
            "lodestar-light": "#5e6d7b",
            "ursa-light": "var(--smar--com--color--azure--700, #064355)",
            "ursa-dark": "var(--smar--com--color--azure--400, #157E9D)",
        },
    },
    {
        name: "color--text--neutral--default",
        description: "The default version of neutral text colors.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--neutral--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--neutral--50, #E5E7F0)",
        },
    },
    {
        name: "color--text--neutral--strong",
        description: "The strong version of neutral text colors.",
        value: {
            "lodestar-light": "#111111",
            "ursa-light": "var(--smar--com--color--neutral--800, #212536)",
            "ursa-dark": "var(--smar--com--color--neutral--00, #FFFFFF)",
        },
    },
    {
        name: "color--text--neutral--stronger",
        description: "The stronger version of neutral text colors. In v4 this is the same as neutral--strong.",
        value: {
            "lodestar-light": "#111111",
            "ursa-light": "var(--smar--com--color--text--neutral--strong, #212536)",
            "ursa-dark": "var(--smar--com--color--neutral--00, #FFFFFF)",
        },
    },
    {
        name: "color--text--neutral--weak",
        description: "The weak version of neutral text colors.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--neutral--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--neutral--100, #B8BDD1)",
        },
    },
    {
        name: "color--text--neutral--weaker",
        description: "The weaker version of neutral text colors.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--neutral--400, #6B7394)",
            "ursa-dark": "var(--smar--com--color--neutral--200, #A6ACC4)",
        },
    },
    {
        name: "color--text--neutral--weakest",
        description: "The weakest version of neutral text colors.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--neutral--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #878DAB)",
        },
    },
    {
        name: "color--text--neutral-inverse--default",
        description: "The weaker version of neutral inverse text colors.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--neutral--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--neutral--75, #D0D3E2)",
        },
    },
    {
        name: "color--text--neutral-inverse--strong",
        description: "The weak version of neutral inverse text colors.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--neutral--00, #FFFFFF)",
            "ursa-dark": "var(--smar--com--color--neutral--00, #FFFFFF)",
        },
    },
    {
        name: "color--text--neutral-inverse--weak",
        description: "The weakest version of neutral inverse text colors.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--neutral--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--neutral--200, #A6ACC4)",
        },
    },
    {
        name: "color--text--primary--default",
        description: "The default version of primary text colors.",
        value: {
            "lodestar-light": "#5996d6",
            "ursa-light": "var(--smar--com--color--blue--600, #184BC3)",
            "ursa-dark": "var(--smar--com--color--blue--60, #C7D8FF)",
        },
    },
    {
        name: "color--text--primary--strong",
        description: "The strong version of primary text colors.",
        value: {
            "lodestar-light": "#007cc5",
            "ursa-light": "var(--smar--com--color--blue--700, #0D3491)",
            "ursa-dark": "var(--smar--com--color--blue--100, #9EBBFF)",
        },
    },
    {
        name: "color--text--primary--stronger",
        description: "The stronger version of primary text colors.",
        value: {
            "lodestar-light": "#004173",
            "ursa-light": "var(--smar--com--color--blue--800, #031C59)",
            "ursa-dark": "var(--smar--com--color--blue--300, #6692FA)",
        },
    },
    {
        name: "color--text--primary--strongest",
        description: "The strongest version of primary text colors.",
        value: {
            "lodestar-light": "#002847",
            "ursa-light": "var(--smar--com--color--blue--900, #000F33)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "color--text--primary--weak",
        description: "The weak version of primary text colors.",
        value: {
            "lodestar-light": "#a7c1e4",
            "ursa-light": "var(--smar--com--color--blue--300, #6692FA)",
            "ursa-dark": "var(--smar--com--color--blue--50, #DBE6FF)",
        },
    },
    {
        name: "color--text--primary--weaker",
        description: "The weaker version of primary text colors.",
        value: {
            "lodestar-light": "#d8e4fa",
            "ursa-light": "var(--smar--com--color--blue--75, #B8CDFF)",
            "ursa-dark": "var(--smar--com--color--blue--35, #EBF1FF)",
        },
    },
    {
        name: "color--text--primary--weakest",
        description: "The weakest version of primary text colors.",
        value: {
            "lodestar-light": "#f0f5fd",
            "ursa-light": "var(--smar--com--color--blue--25, #F5F8FF)",
            "ursa-dark": "var(--smar--com--color--blue--25, #F5F8FF)",
        },
    },
    {
        name: "color--text--slate--default",
        description: "The default version of slate text colors.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--slate--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--text--neutral--default, #E5E7F0)",
        },
    },
    {
        name: "color--text--slate--strong",
        description: "The strong version of slate text colors.",
        value: {
            "lodestar-light": "#111111",
            "ursa-light": "var(--smar--com--color--slate--800, #212536)",
            "ursa-dark": "var(--smar--com--color--text--neutral--strong, #FFFFFF)",
        },
    },
    {
        name: "color--text--slate--weak",
        description: "The weak version of slate text colors.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--slate--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--text--neutral--weak, #B8BDD1)",
        },
    },
    {
        name: "color--text--slate--weaker",
        description: "The weaker version of slate text colors.",
        value: {
            "lodestar-light": "#979797",
            "ursa-light": "var(--smar--com--color--slate--400, #6B7394)",
            "ursa-dark": "var(--smar--com--color--text--neutral--weaker, #A6ACC4)",
        },
    },
    {
        name: "color--text--slate--weakest",
        description: "The weakest version of slate text colors.",
        value: {
            "lodestar-light": "#c0c0c0",
            "ursa-light": "var(--smar--com--color--slate--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--text--neutral--weakest, #878DAB)",
        },
    },
    {
        name: "color--text--slate-inverse--default",
        description: "The default version of slate inverse text colors.",
        value: {
            "lodestar-light": "#f2f2f2",
            "ursa-light": "var(--smar--com--color--slate--25, #F5F6FA)",
            "ursa-dark": "var(--smar--com--color--slate--25, #F5F6FA)",
        },
    },
    {
        name: "color--text--slate-inverse--strong",
        description: "The strong version of slate inverse text colors.",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--neutral--00, #FFFFFF)",
            "ursa-dark": "var(--smar--com--color--neutral--00, #FFFFFF)",
        },
    },
    {
        name: "color--text--slate-inverse--weak",
        description: "The weak version of slate inverse text colors.",
        value: {
            "lodestar-light": "#ebebeb",
            "ursa-light": "var(--smar--com--color--slate--50, #E5E7F0)",
            "ursa-dark": "var(--smar--com--color--slate--50, #E5E7F0)",
        },
    },
    {
        name: "color--text--spectrum-aqua--default",
        description:
            "The default version of spectrum aqua for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004e43",
            "ursa-light": "var(--smar--com--color--aqua--800, #042A23)",
            "ursa-dark": "var(--smar--com--color--aqua--800, #042A23)",
        },
    },
    {
        name: "color--text--spectrum-aqua--strong",
        description:
            "The strong version of spectrum aqua for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#002923",
            "ursa-light": "var(--smar--com--color--aqua--900, #001A17)",
            "ursa-dark": "var(--smar--com--color--aqua--600, #0F6151)",
        },
    },
    {
        name: "color--text--spectrum-azure--default",
        description:
            "The default version of spectrum azure for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004173",
            "ursa-light": "var(--smar--com--color--azure--800, #022A36)",
            "ursa-dark": "var(--smar--com--color--azure--800, #022A36)",
        },
    },
    {
        name: "color--text--spectrum-azure--strong",
        description:
            "The strong version of spectrum azure for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#002847",
            "ursa-light": "var(--smar--com--color--azure--900, #001F33)",
            "ursa-dark": "var(--smar--com--color--azure--600, #0B5C75)",
        },
    },
    {
        name: "color--text--spectrum-blue--default",
        description:
            "The default version of spectrum blue for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004173",
            "ursa-light": "var(--smar--com--color--blue--800, #031C59)",
            "ursa-dark": "var(--smar--com--color--blue--800, #031C59)",
        },
    },
    {
        name: "color--text--spectrum-blue--strong",
        description:
            "The strong version of spectrum blue for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#002847",
            "ursa-light": "var(--smar--com--color--blue--900, #000F33)",
            "ursa-dark": "var(--smar--com--color--blue--600, #184BC3)",
        },
    },
    {
        name: "color--text--spectrum-gold--default",
        description:
            "The default version of spectrum gold for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#653300",
            "ursa-light": "var(--smar--com--color--gold--800, #322301)",
            "ursa-dark": "var(--smar--com--color--gold--800, #322301)",
        },
    },
    {
        name: "color--text--spectrum-gold--strong",
        description:
            "The strong version of spectrum gold for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#492400",
            "ursa-light": "var(--smar--com--color--gold--900, #1A1200)",
            "ursa-dark": "var(--smar--com--color--gold--600, #705006)",
        },
    },
    {
        name: "color--text--spectrum-green--default",
        description:
            "The default version of spectrum green for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#275600",
            "ursa-light": "var(--smar--com--color--green--800, #042F0A)",
            "ursa-dark": "var(--smar--com--color--green--800, #042F0A)",
        },
    },
    {
        name: "color--text--spectrum-green--strong",
        description:
            "The strong version of spectrum green for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#193700",
            "ursa-light": "var(--smar--com--color--green--900, #081A00)",
            "ursa-dark": "var(--smar--com--color--green--600, #0F621C)",
        },
    },
    {
        name: "color--text--spectrum-indigo--default",
        description:
            "The default version of spectrum indigo for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c3491",
            "ursa-light": "var(--smar--com--color--indigo--800, #26026E)",
            "ursa-dark": "var(--smar--com--color--indigo--800, #26026E)",
        },
    },
    {
        name: "color--text--spectrum-indigo--strong",
        description:
            "The strong version of spectrum indigo for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c245b",
            "ursa-light": "var(--smar--com--color--indigo--900, #160042)",
            "ursa-dark": "var(--smar--com--color--indigo--600, #6329D6)",
        },
    },
    {
        name: "color--text--spectrum-indigo--weak",
        description:
            "The weak version of spectrum indigo for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#566ae3",
            "ursa-light": "var(--smar--com--color--indigo--600, #6329D6)",
            "ursa-dark": "var(--smar--com--color--indigo--900, #160042)",
        },
    },
    {
        name: "color--text--spectrum-mint--default",
        description:
            "The default version of spectrum mint for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#00693f",
            "ursa-light": "var(--smar--com--color--mint--800, #042F0A)",
            "ursa-dark": "var(--smar--com--color--mint--800, #042F0A)",
        },
    },
    {
        name: "color--text--spectrum-mint--strong",
        description:
            "The strong version of spectrum mint for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#00462a",
            "ursa-light": "var(--smar--com--color--mint--900, #081A00)",
            "ursa-dark": "var(--smar--com--color--mint--600, #0F621C)",
        },
    },
    {
        name: "color--text--spectrum-neutral--default",
        description:
            "The default version of spectrum neutral for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--neutral--800, #212536)",
            "ursa-dark": "var(--smar--com--color--neutral--800, #212536)",
        },
    },
    {
        name: "color--text--spectrum-neutral--strong",
        description:
            "The strong version of spectrum neutral for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--neutral--900, #11131D)",
            "ursa-dark": "var(--smar--com--color--neutral--700, #363C54)",
        },
    },
    {
        name: "color--text--spectrum-orange--default",
        description:
            "The default version of spectrum orange for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#653300",
            "ursa-light": "var(--smar--com--color--orange--800, #4C1106)",
            "ursa-dark": "var(--smar--com--color--orange--800, #4C1106)",
        },
    },
    {
        name: "color--text--spectrum-orange--strong",
        description:
            "The strong version of spectrum orange for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#492400",
            "ursa-light": "var(--smar--com--color--orange--900, #2D0800)",
            "ursa-dark": "var(--smar--com--color--orange--600, #973421)",
        },
    },
    {
        name: "color--text--spectrum-orchid--default",
        description:
            "The default version of spectrum orchid for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#8b2066",
            "ursa-light": "var(--smar--com--color--orchid--800, #41064B)",
            "ursa-dark": "var(--smar--com--color--orchid--800, #41064B)",
        },
    },
    {
        name: "color--text--spectrum-orchid--strong",
        description:
            "The strong version of spectrum orchid for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#610e44",
            "ursa-light": "var(--smar--com--color--orchid--900, #27002D)",
            "ursa-dark": "var(--smar--com--color--orchid--600, #8B259D)",
        },
    },
    {
        name: "color--text--spectrum-pink--default",
        description:
            "The default version of spectrum pink for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#8b2066",
            "ursa-light": "var(--smar--com--color--pink--800, #4C062F)",
            "ursa-dark": "var(--smar--com--color--pink--800, #4C062F)",
        },
    },
    {
        name: "color--text--spectrum-pink--strong",
        description:
            "The strong version of spectrum pink for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#610e44",
            "ursa-light": "var(--smar--com--color--pink--900, #2E001C)",
            "ursa-dark": "var(--smar--com--color--pink--600, #992468)",
        },
    },
    {
        name: "color--text--spectrum-red--default",
        description:
            "The default version of spectrum red for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#9d0c00",
            "ursa-light": "var(--smar--com--color--red--800, #570006)",
            "ursa-dark": "var(--smar--com--color--red--800, #570006)",
        },
    },
    {
        name: "color--text--spectrum-red--strong",
        description:
            "The strong version of spectrum red for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#6d0800",
            "ursa-light": "var(--smar--com--color--red--900, #330003)",
            "ursa-dark": "var(--smar--com--color--red--600, #AB0D17)",
        },
    },
    {
        name: "color--text--spectrum-rose--default",
        description:
            "The default version of spectrum rose for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#8b2066",
            "ursa-light": "var(--smar--com--color--rose--800, #4C062F)",
            "ursa-dark": "var(--smar--com--color--rose--800, #4C062F)",
        },
    },
    {
        name: "color--text--spectrum-rose--strong",
        description:
            "The strong version of spectrum rose for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#610e44",
            "ursa-light": "var(--smar--com--color--rose--900, #2E001C)",
            "ursa-dark": "var(--smar--com--color--rose--600, #992468)",
        },
    },
    {
        name: "color--text--spectrum-slate--default",
        description:
            "The default version of spectrum slate for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#727272",
            "ursa-light": "var(--smar--com--color--slate--800, #212536)",
            "ursa-dark": "var(--smar--com--color--slate--800, #212536)",
        },
    },
    {
        name: "color--text--spectrum-slate--strong",
        description:
            "The strong version of spectrum slate for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#444444",
            "ursa-light": "var(--smar--com--color--slate--900, #11131D)",
            "ursa-dark": "var(--smar--com--color--slate--600, #4C5470)",
        },
    },
    {
        name: "color--text--spectrum-teal--default",
        description:
            "The default version of spectrum teal for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#004e43",
            "ursa-light": "var(--smar--com--color--teal--800, #042A23)",
            "ursa-dark": "var(--smar--com--color--teal--800, #042A23)",
        },
    },
    {
        name: "color--text--spectrum-teal--strong",
        description:
            "The strong version of spectrum teal for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#002923",
            "ursa-light": "var(--smar--com--color--teal--900, #001A17)",
            "ursa-dark": "var(--smar--com--color--teal--600, #0F6151)",
        },
    },
    {
        name: "color--text--spectrum-violet--default",
        description:
            "The default version of spectrum violet for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c3491",
            "ursa-light": "var(--smar--com--color--violet--800, #26026E)",
            "ursa-dark": "var(--smar--com--color--violet--800, #26026E)",
        },
    },
    {
        name: "color--text--spectrum-violet--strong",
        description:
            "The strong version of spectrum violet for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#0c245b",
            "ursa-light": "var(--smar--com--color--violet--900, #160042)",
            "ursa-dark": "var(--smar--com--color--violet--600, #6329D6)",
        },
    },
    {
        name: "color--text--spectrum-yellow--default",
        description:
            "The default version of spectrum yellow for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#5a4000",
            "ursa-light": "var(--smar--com--color--yellow--800, #322301)",
            "ursa-dark": "var(--smar--com--color--yellow--800, #322301)",
        },
    },
    {
        name: "color--text--spectrum-yellow--strong",
        description:
            "The strong version of spectrum yellow for text colors. This should only be used within special circumstances where you need the full color spectrum.",
        value: {
            "lodestar-light": "#3d2c00",
            "ursa-light": "var(--smar--com--color--yellow--900, #1A1200)",
            "ursa-dark": "var(--smar--com--color--yellow--600, #705006)",
        },
    },
    {
        name: "color--text--success--default",
        description: "The default version of success text colors. Used on success text.",
        value: {
            "lodestar-light": "#00462a",
            "ursa-light": "var(--smar--com--color--green--400, #1D862F)",
            "ursa-dark": "var(--smar--com--color--mint--200, #32C84C)",
        },
    },
    {
        name: "color--text--success--weak",
        description: "The weak version of success text colors. Used on success text.",
        value: {
            "lodestar-light": "#00693f",
            "ursa-light": "var(--smar--com--color--green--500, #177827)",
            "ursa-dark": "var(--smar--com--color--mint--300, #29AE40)",
        },
    },
    {
        name: "color--text--warning--default",
        description: "The default version of warning text colors. Used on warning text.",
        value: {
            "lodestar-light": "#664e18",
            "ursa-light": "var(--smar--com--color--gold--900, #1A1200)",
            "ursa-dark": "var(--smar--com--color--gold--200, #DEA41B)",
        },
    },
    {
        name: "color--text--warning--weak",
        description: "The weak version of warning text colors. Used on warning text.",
        value: {
            "lodestar-light": "#997525",
            "ursa-light": "var(--smar--com--color--gold--500, #88620C)",
            "ursa-dark": "var(--smar--com--color--gold--200, #DEA41B)",
        },
    },
    {
        name: "elevation--default",
        description: "",
        value: {
            "lodestar-light": "0px 4px 16px 0px rgba(0, 0, 0, 0.12)",
            "ursa-light": "0px 4px 6px rgba(54, 60, 84, 0.12), 0px 6px 16px 6px rgba(54, 60, 84, 0.16)",
            "ursa-dark": "0px 4px 6px rgba(17, 19, 29, 0.24), 0px 6px 16px 6px rgba(17, 19, 29, 0.24)",
        },
    },
    {
        name: "elevation--high",
        description: "",
        value: {
            "lodestar-light": "0px 24px 64px rgba(0, 0, 0, 0.12)",
            "ursa-light": "0px 2px 4px rgba(54, 60, 84, 0.12), 0px 12px 24px 8px rgba(54, 60, 84, 0.2)",
            "ursa-dark": "0px 2px 4px rgba(17, 19, 29, 0.2), 0px 12px 24px 8px rgba(17, 19, 29, 0.28)",
        },
    },
    {
        name: "elevation--low",
        description: "",
        value: {
            "lodestar-light": "0px 2px 12px 0px rgba(0, 0, 0, 0.16)",
            "ursa-light": "0px 2px 4px rgba(54, 60, 84, 0.16), 0px 6px 12px rgba(54, 60, 84, 0.12)",
            "ursa-dark": "0px 2px 4px rgba(17, 19, 29, 0.24), 0px 6px 12px rgba(17, 19, 29, 0.32)",
        },
    },
    {
        name: "elevation--shadow-0",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "0px 2px 4px rgba(54, 60, 84, 0.16), 0px 6px 12px rgba(54, 60, 84, 0.12)",
            "ursa-dark": "0px 2px 4px rgba(17, 19, 29, 0.24), 0px 6px 12px rgba(17, 19, 29, 0.32)",
        },
    },
    {
        name: "elevation--shadow-1",
        description: "For menus - both Menu and Select",
        value: {
            "lodestar-light": "0px 2px 12px 0px rgba(0, 0, 0, 0.16)",
            "ursa-light": "0px 2px 4px rgba(54, 60, 84, 0.16), 0px 6px 12px rgba(54, 60, 84, 0.12)",
            "ursa-dark": "0px 2px 4px rgba(17, 19, 29, 0.24), 0px 6px 12px rgba(17, 19, 29, 0.32)",
        },
    },
    {
        name: "elevation--shadow-2",
        description: "Card uses this, Contact Card uses this, Pagination",
        value: {
            "lodestar-light": "0px 4px 16px 0px rgba(0, 0, 0, 0.12)",
            "ursa-light": "0px 4px 6px rgba(54, 60, 84, 0.12), 0px 6px 16px 6px rgba(54, 60, 84, 0.16)",
            "ursa-dark": "0px 4px 6px rgba(17, 19, 29, 0.24), 0px 6px 16px 6px rgba(17, 19, 29, 0.24)",
        },
    },
    {
        name: "elevation--shadow-3",
        description: "For modals, left rails",
        value: {
            "lodestar-light": "0px 24px 64px rgba(0, 0, 0, 0.12)",
            "ursa-light": "0px 2px 4px rgba(54, 60, 84, 0.12), 0px 12px 24px 8px rgba(54, 60, 84, 0.2)",
            "ursa-dark": "0px 2px 4px rgba(17, 19, 29, 0.2), 0px 12px 24px 8px rgba(17, 19, 29, 0.28)",
        },
    },
    {
        name: "focus-indicator--border-primary",
        description: "This is the main outer border for a focus ring",
        value: {
            "lodestar-light": "#6097d2",
            "ursa-light": "var(--smar--com--color--blue--400, #3A6FE9)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "focus-indicator--border-secondary",
        description:
            "This inner border provides more contrast between the focused element for scenarios where the element is on a background other than the work-surface",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--00, #FFFFFF)",
            "ursa-dark": "var(--smar--com--color--neutral--00, #FFFFFF)",
        },
    },
    {
        name: "form-input--border--active",
        description:
            "Used for form elements that have an accompanying menu or popup. When that popup is open, this color is used for the associated control's border.",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--400, #3A6FE9)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "form-input--border--error",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--500, #CE1723)",
            "ursa-dark": "var(--smar--com--color--red--500, #CE1723)",
        },
    },
    {
        name: "form-input--border--focus",
        description: "The border applied to form elements which are currently focused",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--200, #A6ACC4)",
            "ursa-dark": "var(--smar--com--color--neutral--200, #A6ACC4)",
        },
    },
    {
        name: "form-input--border--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--400, #6B7394)",
            "ursa-dark": "var(--smar--com--color--neutral--400, #6B7394)",
        },
    },
    {
        name: "form-input--border--readonly",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--neutral--75, #D0D3E2)",
        },
    },
    {
        name: "form-input--border--rest",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--300, #8D94B0)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #8D94B0)",
        },
    },
    {
        name: "gold--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--600, #705006)",
            "ursa-dark": "var(--smar--com--color--yellow--600, #705006)",
        },
    },
    {
        name: "gold--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--100, #EFB32A)",
            "ursa-dark": "var(--smar--com--color--yellow--100, #EFB32A)",
        },
    },
    {
        name: "gold--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--300, #BF8E1D)",
            "ursa-dark": "var(--smar--com--color--yellow--300, #BF8E1D)",
        },
    },
    {
        name: "gold--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--200, #DEA41B)",
            "ursa-dark": "var(--smar--com--color--yellow--200, #DEA41B)",
        },
    },
    {
        name: "gold--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--500, #88620C)",
            "ursa-dark": "var(--smar--com--color--yellow--500, #88620C)",
        },
    },
    {
        name: "gold--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--900, #1A1200)",
            "ursa-dark": "var(--smar--com--color--yellow--900, #1A1200)",
        },
    },
    {
        name: "gold--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--800, #322301)",
            "ursa-dark": "var(--smar--com--color--yellow--800, #322301)",
        },
    },
    {
        name: "gradient--navigation",
        description: "The linear gradient to power Smartsheet's navigation bar",
        value: {
            "lodestar-light": "#003059",
            "ursa-light": "linear-gradient(180deg, #184BC3, #5A43D7)",
            "ursa-dark": "linear-gradient(180deg, #184BC3, #5A43D7)",
        },
    },
    {
        name: "gradient--upsell",
        description: "The linear gradient to power Smartsheet's upsell banner",
        value: {
            "lodestar-light": "#003059",
            "ursa-light": "linear-gradient(101deg, #F4F1FE 0%, #E3EBFD 33%, #ADC6FA 100%)",
            "ursa-dark": "linear-gradient(101deg, #F4F1FE 0%, #E3EBFD 33%, #ADC6FA 100%)",
        },
    },
    {
        name: "green--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--400, #1D862F)",
            "ursa-dark": "var(--smar--com--color--green--400, #1D862F)",
        },
    },
    {
        name: "green--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--50, #B9F4C3)",
            "ursa-dark": "var(--smar--com--color--green--50, #B9F4C3)",
        },
    },
    {
        name: "green--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--100, #62D574)",
            "ursa-dark": "var(--smar--com--color--green--100, #62D574)",
        },
    },
    {
        name: "green--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--75, #8EE69D)",
            "ursa-dark": "var(--smar--com--color--green--75, #8EE69D)",
        },
    },
    {
        name: "green--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--400, #1D862F)",
            "ursa-dark": "var(--smar--com--color--green--400, #1D862F)",
        },
    },
    {
        name: "green--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--800, #042F0A)",
            "ursa-dark": "var(--smar--com--color--green--800, #042F0A)",
        },
    },
    {
        name: "green--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--600, #0F621C)",
            "ursa-dark": "var(--smar--com--color--green--600, #0F621C)",
        },
    },
    {
        name: "indigo--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--300, #A87EFB)",
            "ursa-dark": "var(--smar--com--color--violet--300, #A87EFB)",
        },
    },
    {
        name: "indigo--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--50, #EBE0FF)",
            "ursa-dark": "var(--smar--com--color--violet--50, #EBE0FF)",
        },
    },
    {
        name: "indigo--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--100, #C9ADFF)",
            "ursa-dark": "var(--smar--com--color--violet--100, #C9ADFF)",
        },
    },
    {
        name: "indigo--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--75, #D6C2FF)",
            "ursa-dark": "var(--smar--com--color--violet--75, #D6C2FF)",
        },
    },
    {
        name: "indigo--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--400, #8959E8)",
            "ursa-dark": "var(--smar--com--color--violet--400, #8959E8)",
        },
    },
    {
        name: "indigo--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--800, #26026E)",
            "ursa-dark": "var(--smar--com--color--violet--800, #26026E)",
        },
    },
    {
        name: "indigo--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--500, #7847DC)",
            "ursa-dark": "var(--smar--com--color--violet--500, #7847DC)",
        },
    },
    {
        name: "mint--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--300, #29AE40)",
            "ursa-dark": "var(--smar--com--color--green--300, #29AE40)",
        },
    },
    {
        name: "mint--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--50, #B9F4C3)",
            "ursa-dark": "var(--smar--com--color--green--50, #B9F4C3)",
        },
    },
    {
        name: "mint--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--100, #62D574)",
            "ursa-dark": "var(--smar--com--color--green--100, #62D574)",
        },
    },
    {
        name: "mint--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--75, #8EE69D)",
            "ursa-dark": "var(--smar--com--color--green--75, #8EE69D)",
        },
    },
    {
        name: "mint--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--300, #29AE40)",
            "ursa-dark": "var(--smar--com--color--green--300, #29AE40)",
        },
    },
    {
        name: "mint--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--800, #042F0A)",
            "ursa-dark": "var(--smar--com--color--green--800, #042F0A)",
        },
    },
    {
        name: "mint--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--600, #0F621C)",
            "ursa-dark": "var(--smar--com--color--green--600, #0F621C)",
        },
    },
    {
        name: "neutral--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--300, #8D94B0)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #8D94B0)",
        },
    },
    {
        name: "neutral--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--50, #E5E7F0)",
            "ursa-dark": "var(--smar--com--color--neutral--50, #E5E7F0)",
        },
    },
    {
        name: "neutral--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--100, #B8BDD1)",
            "ursa-dark": "var(--smar--com--color--neutral--100, #B8BDD1)",
        },
    },
    {
        name: "neutral--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--neutral--75, #D0D3E2)",
        },
    },
    {
        name: "neutral--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--300, #8D94B0)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #8D94B0)",
        },
    },
    {
        name: "neutral--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--800, #212536)",
            "ursa-dark": "var(--smar--com--color--neutral--800, #212536)",
        },
    },
    {
        name: "neutral--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--neutral--500, #5F6786)",
        },
    },
    {
        name: "orange--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orange--500, #B84028)",
            "ursa-dark": "var(--smar--com--color--orange--500, #B84028)",
        },
    },
    {
        name: "orange--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orange--75, #FEC8BE)",
            "ursa-dark": "var(--smar--com--color--orange--75, #FEC8BE)",
        },
    },
    {
        name: "orange--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orange--200, #FB8F79)",
            "ursa-dark": "var(--smar--com--color--orange--200, #FB8F79)",
        },
    },
    {
        name: "orange--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orange--100, #FDA796)",
            "ursa-dark": "var(--smar--com--color--orange--100, #FDA796)",
        },
    },
    {
        name: "orange--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orange--400, #D64529)",
            "ursa-dark": "var(--smar--com--color--orange--400, #D64529)",
        },
    },
    {
        name: "orange--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orange--900, #2D0800)",
            "ursa-dark": "var(--smar--com--color--orange--900, #2D0800)",
        },
    },
    {
        name: "orange--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orange--700, #732111)",
            "ursa-dark": "var(--smar--com--color--orange--700, #732111)",
        },
    },
    {
        name: "orchid--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orchid--300, #CE73DE)",
            "ursa-dark": "var(--smar--com--color--orchid--300, #CE73DE)",
        },
    },
    {
        name: "orchid--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orchid--50, #F8DDFD)",
            "ursa-dark": "var(--smar--com--color--orchid--50, #F8DDFD)",
        },
    },
    {
        name: "orchid--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orchid--100, #E5A7F1)",
            "ursa-dark": "var(--smar--com--color--orchid--100, #E5A7F1)",
        },
    },
    {
        name: "orchid--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orchid--75, #F0C3F8)",
            "ursa-dark": "var(--smar--com--color--orchid--75, #F0C3F8)",
        },
    },
    {
        name: "orchid--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orchid--400, #B53DCC)",
            "ursa-dark": "var(--smar--com--color--orchid--400, #B53DCC)",
        },
    },
    {
        name: "orchid--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orchid--800, #41064B)",
            "ursa-dark": "var(--smar--com--color--orchid--800, #41064B)",
        },
    },
    {
        name: "orchid--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--orchid--600, #8B259D)",
            "ursa-dark": "var(--smar--com--color--orchid--600, #8B259D)",
        },
    },
    {
        name: "pink--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--300, #E76AB3)",
            "ursa-dark": "var(--smar--com--color--pink--300, #E76AB3)",
        },
    },
    {
        name: "pink--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--50, #FEE1F2)",
            "ursa-dark": "var(--smar--com--color--pink--50, #FEE1F2)",
        },
    },
    {
        name: "pink--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--100, #F9A4D6)",
            "ursa-dark": "var(--smar--com--color--pink--100, #F9A4D6)",
        },
    },
    {
        name: "pink--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--75, #FDC4E4)",
            "ursa-dark": "var(--smar--com--color--pink--75, #FDC4E4)",
        },
    },
    {
        name: "pink--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--400, #CE3B91)",
            "ursa-dark": "var(--smar--com--color--pink--400, #CE3B91)",
        },
    },
    {
        name: "pink--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--800, #4C062F)",
            "ursa-dark": "var(--smar--com--color--pink--800, #4C062F)",
        },
    },
    {
        name: "pink--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--600, #992468)",
            "ursa-dark": "var(--smar--com--color--pink--600, #992468)",
        },
    },
    {
        name: "red--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--300, #E96D75)",
            "ursa-dark": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "red--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--50, #FFE0E3)",
            "ursa-dark": "var(--smar--com--color--red--50, #FFE0E3)",
        },
    },
    {
        name: "red--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--100, #F7ABB0)",
            "ursa-dark": "var(--smar--com--color--red--100, #F7ABB0)",
        },
    },
    {
        name: "red--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--75, #FBC6C9)",
            "ursa-dark": "var(--smar--com--color--red--75, #FBC6C9)",
        },
    },
    {
        name: "red--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--400, #DF2A36)",
            "ursa-dark": "var(--smar--com--color--red--400, #DF2A36)",
        },
    },
    {
        name: "red--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--800, #570006)",
            "ursa-dark": "var(--smar--com--color--red--800, #570006)",
        },
    },
    {
        name: "red--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--600, #AB0D17)",
            "ursa-dark": "var(--smar--com--color--red--600, #AB0D17)",
        },
    },
    {
        name: "rose--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--200, #F589C8)",
            "ursa-dark": "var(--smar--com--color--pink--200, #F589C8)",
        },
    },
    {
        name: "rose--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--50, #FEE1F2)",
            "ursa-dark": "var(--smar--com--color--pink--50, #FEE1F2)",
        },
    },
    {
        name: "rose--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--100, #F9A4D6)",
            "ursa-dark": "var(--smar--com--color--pink--100, #F9A4D6)",
        },
    },
    {
        name: "rose--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--75, #FDC4E4)",
            "ursa-dark": "var(--smar--com--color--pink--75, #FDC4E4)",
        },
    },
    {
        name: "rose--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--400, #CE3B91)",
            "ursa-dark": "var(--smar--com--color--pink--400, #CE3B91)",
        },
    },
    {
        name: "rose--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--800, #4C062F)",
            "ursa-dark": "var(--smar--com--color--pink--800, #4C062F)",
        },
    },
    {
        name: "rose--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--pink--500, #B53680)",
            "ursa-dark": "var(--smar--com--color--pink--500, #B53680)",
        },
    },
    {
        name: "selection--border",
        description: "Default select border",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "selection--border-alt",
        description: "Card hover",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--300, #8D94B0)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #8D94B0)",
        },
    },
    {
        name: "selection--border-glow",
        description: "Selection outer/inner glow",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--75, #B8CDFF)",
            "ursa-dark": "var(--smar--com--color--blue--75, #B8CDFF)",
        },
    },
    {
        name: "selection--range--border",
        description: "Default select range/container border",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--blue--400, #3A6FE9)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "semantic--error--background",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": "var(--smar--com--color--red--75, #FBC6C9)",
            "ursa-light": "var(--smar--com--color--red--50, #FFE0E3)",
            "ursa-dark": "var(--smar--com--color--red--50, #FFE0E3)",
        },
    },
    {
        name: "semantic--error--background--active",
        description: "",
        value: {
            "lodestar-light": "#e4969c",
            "ursa-light": "var(--smar--com--color--red--100, #F7ABB0)",
            "ursa-dark": "var(--smar--com--color--red--100, #F7ABB0)",
        },
    },
    {
        name: "semantic--error--background--hover",
        description: "",
        value: {
            "lodestar-light": "#e4969c",
            "ursa-light": "var(--smar--com--color--red--75, #FBC6C9)",
            "ursa-dark": "var(--smar--com--color--red--75, #FBC6C9)",
        },
    },
    {
        name: "semantic--error--border",
        description: "Background color for elements that present critical information",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--red--500, #CE1723)",
            "ursa-dark": "var(--smar--com--color--red--500, #CE1723)",
        },
    },
    {
        name: "semantic--error--icon",
        description: "Used for icons",
        value: {
            "lodestar-light": "var(--smar--com--color--red--600, #AB0D17)",
            "ursa-light": "var(--smar--com--color--red--600, #AB0D17)",
            "ursa-dark": "var(--smar--com--color--red--600, #AB0D17)",
        },
    },
    {
        name: "semantic--error--text",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": "var(--smar--com--color--red--900, #330003)",
            "ursa-light": "var(--smar--com--color--red--800, #570006)",
            "ursa-dark": "var(--smar--com--color--red--800, #570006)",
        },
    },
    {
        name: "semantic--error--text-inline",
        description: "Used for input validation",
        value: {
            "lodestar-light": "var(--smar--com--color--red--600, #AB0D17)",
            "ursa-light": "var(--smar--com--color--red--600, #AB0D17)",
            "ursa-dark": "var(--smar--com--color--red--600, #AB0D17)",
        },
    },
    {
        name: "semantic--info--background",
        description: "Backgrounds for banners and toasts",
        value: {
            "lodestar-light": "var(--smar--com--color--azure--75, #98DCF1)",
            "ursa-light": "var(--smar--com--color--blue--50, #DBE6FF)",
            "ursa-dark": "var(--smar--com--color--blue--50, #DBE6FF)",
        },
    },
    {
        name: "semantic--info--background--active",
        description: "",
        value: {
            "lodestar-light": "#cbd8e3",
            "ursa-light": "var(--smar--com--color--blue--100, #9EBBFF)",
            "ursa-dark": "var(--smar--com--color--blue--100, #9EBBFF)",
        },
    },
    {
        name: "semantic--info--background--hover",
        description: "",
        value: {
            "lodestar-light": "#cbd8e3",
            "ursa-light": "var(--smar--com--color--blue--75, #B8CDFF)",
            "ursa-dark": "var(--smar--com--color--blue--75, #B8CDFF)",
        },
    },
    {
        name: "semantic--info--border",
        description: "Background color for elements that inform the user of some information",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--azure--500, #10718E)",
            "ursa-dark": "var(--smar--com--color--azure--500, #10718E)",
        },
    },
    {
        name: "semantic--info--icon",
        description: "Used for icons",
        value: {
            "lodestar-light": "var(--smar--com--color--azure--600, #0B5C75)",
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "semantic--info--text",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": "var(--smar--com--color--azure--900, #001F33)",
            "ursa-light": "var(--smar--com--color--blue--800, #031C59)",
            "ursa-dark": "var(--smar--com--color--blue--800, #031C59)",
        },
    },
    {
        name: "semantic--info--text-inline",
        description: "Used for input validation",
        value: {
            "lodestar-light": "var(--smar--com--color--azure--600, #0B5C75)",
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "semantic--success--background",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": "var(--smar--com--color--green--50, #B9F4C3)",
            "ursa-light": "var(--smar--com--color--green--50, #B9F4C3)",
            "ursa-dark": "var(--smar--com--color--green--50, #B9F4C3)",
        },
    },
    {
        name: "semantic--success--background--active",
        description: "",
        value: {
            "lodestar-light": "#7dd4b1",
            "ursa-light": "var(--smar--com--color--green--100, #62D574)",
            "ursa-dark": "var(--smar--com--color--green--100, #62D574)",
        },
    },
    {
        name: "semantic--success--background--hover",
        description: "",
        value: {
            "lodestar-light": "#7dd4b1",
            "ursa-light": "var(--smar--com--color--green--75, #8EE69D)",
            "ursa-dark": "var(--smar--com--color--green--75, #8EE69D)",
        },
    },
    {
        name: "semantic--success--border",
        description: "Background color for elements that present a favorable outcome",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--green--500, #177827)",
            "ursa-dark": "var(--smar--com--color--green--500, #177827)",
        },
    },
    {
        name: "semantic--success--icon",
        description: "Used for icons",
        value: {
            "lodestar-light": "var(--smar--com--color--green--500, #177827)",
            "ursa-light": "var(--smar--com--color--green--600, #0F621C)",
            "ursa-dark": "var(--smar--com--color--green--600, #0F621C)",
        },
    },
    {
        name: "semantic--success--text",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": "var(--smar--com--color--green--900, #081A00)",
            "ursa-light": "var(--smar--com--color--green--800, #042F0A)",
            "ursa-dark": "var(--smar--com--color--green--800, #042F0A)",
        },
    },
    {
        name: "semantic--success--text-inline",
        description: "Used for input validation",
        value: {
            "lodestar-light": "var(--smar--com--color--green--600, #0F621C)",
            "ursa-light": "var(--smar--com--color--green--600, #0F621C)",
            "ursa-dark": "var(--smar--com--color--green--600, #0F621C)",
        },
    },
    {
        name: "semantic--warning--background",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": "var(--smar--com--color--yellow--75, #F9CD67)",
            "ursa-light": "var(--smar--com--color--yellow--100, #EFB32A)",
            "ursa-dark": "var(--smar--com--color--yellow--100, #EFB32A)",
        },
    },
    {
        name: "semantic--warning--background--active",
        description: "",
        value: {
            "lodestar-light": "#fcde9b",
            "ursa-light": "var(--smar--com--color--yellow--300, #BF8E1D)",
            "ursa-dark": "var(--smar--com--color--yellow--300, #BF8E1D)",
        },
    },
    {
        name: "semantic--warning--background--hover",
        description: "",
        value: {
            "lodestar-light": "#fcde9b",
            "ursa-light": "var(--smar--com--color--yellow--200, #DEA41B)",
            "ursa-dark": "var(--smar--com--color--yellow--200, #DEA41B)",
        },
    },
    {
        name: "semantic--warning--border",
        description: "Background color for elements that provide caution",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--500, #88620C)",
            "ursa-dark": "var(--smar--com--color--yellow--500, #88620C)",
        },
    },
    {
        name: "semantic--warning--icon",
        description: "Used for icons",
        value: {
            "lodestar-light": "var(--smar--com--color--yellow--700, #543B03)",
            "ursa-light": "var(--smar--com--color--yellow--800, #322301)",
            "ursa-dark": "var(--smar--com--color--yellow--800, #322301)",
        },
    },
    {
        name: "semantic--warning--text",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": "var(--smar--com--color--yellow--900, #1A1200)",
            "ursa-light": "var(--smar--com--color--yellow--900, #1A1200)",
            "ursa-dark": "var(--smar--com--color--yellow--900, #1A1200)",
        },
    },
    {
        name: "semantic--warning--text-inline",
        description: "Used for input validation",
        value: {
            "lodestar-light": "var(--smar--com--color--yellow--700, #543B03)",
            "ursa-light": "var(--smar--com--color--yellow--800, #322301)",
            "ursa-dark": "var(--smar--com--color--yellow--800, #322301)",
        },
    },
    {
        name: "slate--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--300, #8D94B0)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #8D94B0)",
        },
    },
    {
        name: "slate--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--50, #E5E7F0)",
            "ursa-dark": "var(--smar--com--color--neutral--50, #E5E7F0)",
        },
    },
    {
        name: "slate--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--100, #B8BDD1)",
            "ursa-dark": "var(--smar--com--color--neutral--100, #B8BDD1)",
        },
    },
    {
        name: "slate--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--neutral--75, #D0D3E2)",
        },
    },
    {
        name: "slate--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--300, #8D94B0)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #8D94B0)",
        },
    },
    {
        name: "slate--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--800, #212536)",
            "ursa-dark": "var(--smar--com--color--neutral--800, #212536)",
        },
    },
    {
        name: "slate--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--neutral--500, #5F6786)",
        },
    },
    {
        name: "surface--canvas--background",
        description: "Default canvas surface background color",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--neutral--25, #F5F6FA)",
            "ursa-dark": "var(--smar--com--color--neutral--25, #F5F6FA)",
        },
    },
    {
        name: "surface--canvas--border",
        description: "top of work surface line",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--50, #E5E7F0)",
            "ursa-dark": "var(--smar--com--color--neutral--50, #E5E7F0)",
        },
    },
    {
        name: "surface--canvas--border-scroll",
        description: "Scroll border when scrolling below fixed areas like headers.",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--100, #B8BDD1)",
            "ursa-dark": "var(--smar--com--color--neutral--100, #B8BDD1)",
        },
    },
    {
        name: "surface--canvas--divider",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--neutral--75, #D0D3E2)",
        },
    },
    {
        name: "surface--canvas--text",
        description: "Default canvas surface text color",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--700, #363C54)",
            "ursa-dark": "var(--smar--com--color--neutral--700, #363C54)",
        },
    },
    {
        name: "surface--work--background",
        description: "Default work surface background color",
        value: {
            "lodestar-light": "#ffffff",
            "ursa-light": "var(--smar--com--color--neutral--00, #FFFFFF)",
            "ursa-dark": "var(--smar--com--color--neutral--00, #FFFFFF)",
        },
    },
    {
        name: "surface--work--background--hint",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--25, #F5F6FA)",
            "ursa-dark": "var(--smar--com--color--neutral--25, #F5F6FA)",
        },
    },
    {
        name: "surface--work--divider",
        description: "column header line",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--50, #E5E7F0)",
            "ursa-dark": "var(--smar--com--color--neutral--50, #E5E7F0)",
        },
    },
    {
        name: "surface--work--divider-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--75, #D0D3E2)",
            "ursa-dark": "var(--smar--com--color--neutral--75, #D0D3E2)",
        },
    },
    {
        name: "surface--work--divider-scroll",
        description: "scroll or column freeze line",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--50, #E5E7F0)",
            "ursa-dark": "var(--smar--com--color--neutral--50, #E5E7F0)",
        },
    },
    {
        name: "surface--work--text",
        description: "Default work surface text color",
        value: {
            "lodestar-light": "#111111",
            "ursa-light": "var(--smar--com--color--neutral--800, #212536)",
            "ursa-dark": "var(--smar--com--color--neutral--800, #212536)",
        },
    },
    {
        name: "surface--work--text--inactive",
        description: "Used for readonly form fields sometimes",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--400, #6B7394)",
            "ursa-dark": "var(--smar--com--color--neutral--400, #6B7394)",
        },
    },
    {
        name: "surface--work--text--inactive-hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--neutral--500, #5F6786)",
            "ursa-dark": "var(--smar--com--color--neutral--500, #5F6786)",
        },
    },
    {
        name: "teal--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--400, #1C826D)",
            "ursa-dark": "var(--smar--com--color--teal--400, #1C826D)",
        },
    },
    {
        name: "teal--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--50, #B5F2E6)",
            "ursa-dark": "var(--smar--com--color--teal--50, #B5F2E6)",
        },
    },
    {
        name: "teal--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--100, #5AD3BB)",
            "ursa-dark": "var(--smar--com--color--teal--100, #5AD3BB)",
        },
    },
    {
        name: "teal--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--75, #86E4D1)",
            "ursa-dark": "var(--smar--com--color--teal--75, #86E4D1)",
        },
    },
    {
        name: "teal--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--300, #28A98F)",
            "ursa-dark": "var(--smar--com--color--teal--300, #28A98F)",
        },
    },
    {
        name: "teal--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--800, #042A23)",
            "ursa-dark": "var(--smar--com--color--teal--800, #042A23)",
        },
    },
    {
        name: "teal--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--teal--600, #0F6151)",
            "ursa-dark": "var(--smar--com--color--teal--600, #0F6151)",
        },
    },
    {
        name: "violet--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--300, #A87EFB)",
            "ursa-dark": "var(--smar--com--color--violet--300, #A87EFB)",
        },
    },
    {
        name: "violet--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--50, #EBE0FF)",
            "ursa-dark": "var(--smar--com--color--violet--50, #EBE0FF)",
        },
    },
    {
        name: "violet--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--100, #C9ADFF)",
            "ursa-dark": "var(--smar--com--color--violet--100, #C9ADFF)",
        },
    },
    {
        name: "violet--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--75, #D6C2FF)",
            "ursa-dark": "var(--smar--com--color--violet--75, #D6C2FF)",
        },
    },
    {
        name: "violet--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--400, #8959E8)",
            "ursa-dark": "var(--smar--com--color--violet--400, #8959E8)",
        },
    },
    {
        name: "violet--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--800, #26026E)",
            "ursa-dark": "var(--smar--com--color--violet--800, #26026E)",
        },
    },
    {
        name: "violet--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--violet--500, #7847DC)",
            "ursa-dark": "var(--smar--com--color--violet--500, #7847DC)",
        },
    },
    {
        name: "yellow--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--600, #705006)",
            "ursa-dark": "var(--smar--com--color--yellow--600, #705006)",
        },
    },
    {
        name: "yellow--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--100, #EFB32A)",
            "ursa-dark": "var(--smar--com--color--yellow--100, #EFB32A)",
        },
    },
    {
        name: "yellow--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--300, #BF8E1D)",
            "ursa-dark": "var(--smar--com--color--yellow--300, #BF8E1D)",
        },
    },
    {
        name: "yellow--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--200, #DEA41B)",
            "ursa-dark": "var(--smar--com--color--yellow--200, #DEA41B)",
        },
    },
    {
        name: "yellow--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--500, #88620C)",
            "ursa-dark": "var(--smar--com--color--yellow--500, #88620C)",
        },
    },
    {
        name: "yellow--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--900, #1A1200)",
            "ursa-dark": "var(--smar--com--color--yellow--900, #1A1200)",
        },
    },
    {
        name: "yellow--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "var(--smar--com--color--yellow--800, #322301)",
            "ursa-dark": "var(--smar--com--color--yellow--800, #322301)",
        },
    },
    {
        name: "color--border--destructive--default",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--red--500, #CE1723)",
            "ursa-dark": "var(--smar--com--color--red--300, #E96D75)",
            "lodestar-light": "var(--smar--com--color--red--500, #CE1723)",
        },
    },
    {
        name: "color--border--destructive--weak",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--red--300, #E96D75)",
            "ursa-dark": "var(--smar--com--color--red--400, #DF2A36)",
            "lodestar-light": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "color--border--destructive--weaker",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--red--100, #F7ABB0)",
            "ursa-dark": "var(--smar--com--color--red--500, #CE1723)",
            "lodestar-light": "var(--smar--com--color--red--100, #F7ABB0)",
        },
    },
    {
        name: "color--border--destructive--weakest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--red--75, #FBC6C9)",
            "ursa-dark": "var(--smar--com--color--red--600, #AB0D17)",
            "lodestar-light": "var(--smar--com--color--red--75, #FBC6C9)",
        },
    },
    {
        name: "color--icons--destructive-inverse--weakest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--red--25, #FFF5F6)",
            "ursa-dark": "var(--smar--com--color--red--25, #FFF5F6)",
            "lodestar-light": "var(--smar--com--color--red--25, #FFF5F6)",
        },
    },
    {
        name: "color--elevation-high--top",
        description: "",
        value: { "ursa-light": "#363C541A", "ursa-dark": "#11131D33", "lodestar-light": "#363C541A" },
    },
    {
        name: "color--elevation-high--bottom",
        description: "",
        value: { "ursa-light": "#363C5424", "ursa-dark": "#11131D47", "lodestar-light": "#363C5424" },
    },
    {
        name: "color--elevation-default--top",
        description: "",
        value: { "ursa-light": "#363C541F", "ursa-dark": "#11131D3D", "lodestar-light": "#363C541F" },
    },
    {
        name: "color--elevation-default--bottom",
        description: "",
        value: { "ursa-light": "#363C541F", "ursa-dark": "#11131D3D", "lodestar-light": "#363C541F" },
    },
    {
        name: "color--elevation-low--top",
        description: "",
        value: { "ursa-light": "#363C541F", "ursa-dark": "#11131D3D", "lodestar-light": "#363C541F" },
    },
    {
        name: "color--elevation-low--bottom",
        description: "",
        value: { "ursa-light": "#363C5429", "ursa-dark": "#11131D52", "lodestar-light": "#363C5429" },
    },
    {
        name: "color--charts--high-contrast--1--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--800, #031C59)",
            "ursa-dark": "var(--smar--com--color--blue--100, #9EBBFF)",
            "lodestar-light": "var(--smar--com--color--blue--800, #031C59)",
        },
    },
    {
        name: "color--charts--high-contrast--1--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--900, #000F33)",
            "ursa-dark": "var(--smar--com--color--blue--75, #B8CDFF)",
            "lodestar-light": "var(--smar--com--color--blue--900, #000F33)",
        },
    },
    {
        name: "color--charts--high-contrast--2--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--400, #3A6FE9)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
            "lodestar-light": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "color--charts--high-contrast--2--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--300, #6692FA)",
            "lodestar-light": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "color--charts--high-contrast--3--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--teal--400, #1C826D)",
            "ursa-dark": "var(--smar--com--color--teal--400, #1C826D)",
            "lodestar-light": "var(--smar--com--color--teal--400, #1C826D)",
        },
    },
    {
        name: "color--charts--high-contrast--3--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--teal--500, #167461)",
            "ursa-dark": "var(--smar--com--color--teal--300, #28A98F)",
            "lodestar-light": "var(--smar--com--color--teal--500, #167461)",
        },
    },
    {
        name: "color--charts--high-contrast--4--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--violet--400, #8959E8)",
            "ursa-dark": "var(--smar--com--color--violet--400, #8959E8)",
            "lodestar-light": "var(--smar--com--color--violet--400, #8959E8)",
        },
    },
    {
        name: "color--charts--high-contrast--4--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--violet--500, #7847DC)",
            "ursa-dark": "var(--smar--com--color--violet--300, #A87EFB)",
            "lodestar-light": "var(--smar--com--color--violet--500, #7847DC)",
        },
    },
    {
        name: "color--charts--high-contrast--5--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--neutral--600, #4C5470)",
            "ursa-dark": "var(--smar--com--color--neutral--400, #6B7394)",
            "lodestar-light": "var(--smar--com--color--neutral--600, #4C5470)",
        },
    },
    {
        name: "color--charts--high-contrast--5--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--neutral--700, #363C54)",
            "ursa-dark": "var(--smar--com--color--neutral--300, #878DAB)",
            "lodestar-light": "var(--smar--com--color--neutral--700, #363C54)",
        },
    },
    {
        name: "color--charts--high-contrast--6--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--400, #D64529)",
            "ursa-dark": "var(--smar--com--color--orange--100, #FDA796)",
            "lodestar-light": "var(--smar--com--color--orange--400, #D64529)",
        },
    },
    {
        name: "color--charts--high-contrast--6--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--500, #B84028)",
            "ursa-dark": "var(--smar--com--color--orange--75, #FEC8BE)",
            "lodestar-light": "var(--smar--com--color--orange--500, #B84028)",
        },
    },
    {
        name: "color--charts--high-contrast--7--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--azure--400, #157E9D)",
            "ursa-dark": "var(--smar--com--color--azure--200, #3AB9DF)",
            "lodestar-light": "var(--smar--com--color--azure--400, #157E9D)",
        },
    },
    {
        name: "color--charts--high-contrast--7--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--azure--500, #10718E)",
            "ursa-dark": "var(--smar--com--color--azure--100, #6ACAE7)",
            "lodestar-light": "var(--smar--com--color--azure--500, #10718E)",
        },
    },
    {
        name: "color--charts--high-contrast--8--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--yellow--400, #966E13)",
            "ursa-dark": "var(--smar--com--color--yellow--200, #DEA41B)",
            "lodestar-light": "var(--smar--com--color--yellow--400, #966E13)",
        },
    },
    {
        name: "color--charts--high-contrast--8--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--yellow--500, #88620C)",
            "ursa-dark": "var(--smar--com--color--yellow--100, #EFB32A)",
            "lodestar-light": "var(--smar--com--color--yellow--500, #88620C)",
        },
    },
    {
        name: "color--charts--high-contrast--9--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--700, #094814)",
            "ursa-dark": "var(--smar--com--color--green--400, #1D862F)",
            "lodestar-light": "var(--smar--com--color--green--700, #094814)",
        },
    },
    {
        name: "color--charts--high-contrast--9--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--800, #042F0A)",
            "ursa-dark": "var(--smar--com--color--green--300, #29AE40)",
            "lodestar-light": "var(--smar--com--color--green--800, #042F0A)",
        },
    },
    {
        name: "color--charts--high-contrast--10--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--400, #1D862F)",
            "ursa-dark": "var(--smar--com--color--green--100, #62D574)",
            "lodestar-light": "var(--smar--com--color--green--400, #1D862F)",
        },
    },
    {
        name: "color--charts--high-contrast--10--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--500, #177827)",
            "ursa-dark": "var(--smar--com--color--green--60, #A1EDAD)",
            "lodestar-light": "var(--smar--com--color--green--500, #177827)",
        },
    },
    {
        name: "color--charts--high-contrast--11--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orchid--400, #B53DCC)",
            "ursa-dark": "var(--smar--com--color--orchid--300, #CE73DE)",
            "lodestar-light": "var(--smar--com--color--orchid--400, #B53DCC)",
        },
    },
    {
        name: "color--charts--high-contrast--11--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orchid--500, #A531B9)",
            "ursa-dark": "var(--smar--com--color--orchid--200, #DB91E8)",
            "lodestar-light": "var(--smar--com--color--orchid--500, #A531B9)",
        },
    },
    {
        name: "color--charts--high-contrast--12--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--600, #973421)",
            "ursa-dark": "var(--smar--com--color--orange--400, #D64529)",
            "lodestar-light": "var(--smar--com--color--orange--600, #973421)",
        },
    },
    {
        name: "color--charts--high-contrast--12--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--700, #732111)",
            "ursa-dark": "var(--smar--com--color--orange--300, #F06B51)",
            "lodestar-light": "var(--smar--com--color--orange--700, #732111)",
        },
    },
    {
        name: "color--charts--colorful--1--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--400, #3A6FE9)",
            "ursa-dark": "var(--smar--com--color--blue--100, #9EBBFF)",
            "lodestar-light": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "color--charts--colorful--1--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--60, #C7D8FF)",
            "lodestar-light": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "color--charts--colorful--2--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--100, #62D574)",
            "ursa-dark": "var(--smar--com--color--green--50, #B9F4C3)",
            "lodestar-light": "var(--smar--com--color--green--100, #62D574)",
        },
    },
    {
        name: "color--charts--colorful--2--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--200, #32C84C)",
            "ursa-dark": "var(--smar--com--color--green--50, #B9F4C3)",
            "lodestar-light": "var(--smar--com--color--green--200, #32C84C)",
        },
    },
    {
        name: "color--charts--colorful--3--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--yellow--60, #FBDA8D)",
            "ursa-dark": "var(--smar--com--color--yellow--100, #EFB32A)",
            "lodestar-light": "var(--smar--com--color--yellow--60, #FBDA8D)",
        },
    },
    {
        name: "color--charts--colorful--3--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--yellow--75, #F9CD67)",
            "ursa-dark": "var(--smar--com--color--yellow--50, #FDE6AF)",
            "lodestar-light": "var(--smar--com--color--yellow--75, #F9CD67)",
        },
    },
    {
        name: "color--charts--colorful--4--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--300, #F06B51)",
            "ursa-dark": "var(--smar--com--color--orange--300, #F06B51)",
            "lodestar-light": "var(--smar--com--color--orange--300, #F06B51)",
        },
    },
    {
        name: "color--charts--colorful--4--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--400, #D64529)",
            "ursa-dark": "var(--smar--com--color--orange--200, #FB8F79)",
            "lodestar-light": "var(--smar--com--color--orange--400, #D64529)",
        },
    },
    {
        name: "color--charts--colorful--5--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--100, #FDA796)",
            "ursa-dark": "var(--smar--com--color--orange--100, #FDA796)",
            "lodestar-light": "var(--smar--com--color--orange--100, #FDA796)",
        },
    },
    {
        name: "color--charts--colorful--5--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--200, #FB8F79)",
            "ursa-dark": "var(--smar--com--color--orange--75, #FEC8BE)",
            "lodestar-light": "var(--smar--com--color--orange--200, #FB8F79)",
        },
    },
    {
        name: "color--charts--colorful--6--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orchid--60, #F5D0FB)",
            "ursa-dark": "var(--smar--com--color--orchid--100, #E5A7F1)",
            "lodestar-light": "var(--smar--com--color--orchid--60, #F5D0FB)",
        },
    },
    {
        name: "color--charts--colorful--6--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orchid--75, #F0C3F8)",
            "ursa-dark": "var(--smar--com--color--orchid--75, #F0C3F8)",
            "lodestar-light": "var(--smar--com--color--orchid--75, #F0C3F8)",
        },
    },
    {
        name: "color--charts--colorful--7--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orchid--300, #CE73DE)",
            "ursa-dark": "var(--smar--com--color--orchid--300, #CE73DE)",
            "lodestar-light": "var(--smar--com--color--orchid--300, #CE73DE)",
        },
    },
    {
        name: "color--charts--colorful--7--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orchid--400, #B53DCC)",
            "ursa-dark": "var(--smar--com--color--orchid--200, #DB91E8)",
            "lodestar-light": "var(--smar--com--color--orchid--400, #B53DCC)",
        },
    },
    {
        name: "color--charts--colorful--8--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--azure--75, #98DCF1)",
            "ursa-dark": "var(--smar--com--color--azure--75, #98DCF1)",
            "lodestar-light": "var(--smar--com--color--azure--75, #98DCF1)",
        },
    },
    {
        name: "color--charts--colorful--8--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--azure--100, #6ACAE7)",
            "ursa-dark": "var(--smar--com--color--azure--50, #C6EFFA)",
            "lodestar-light": "var(--smar--com--color--azure--100, #6ACAE7)",
        },
    },
    {
        name: "color--charts--colorful--9--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--azure--300, #1EA0C8)",
            "ursa-dark": "var(--smar--com--color--azure--300, #1EA0C8)",
            "lodestar-light": "var(--smar--com--color--azure--300, #1EA0C8)",
        },
    },
    {
        name: "color--charts--colorful--9--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--azure--400, #157E9D)",
            "ursa-dark": "var(--smar--com--color--azure--200, #3AB9DF)",
            "lodestar-light": "var(--smar--com--color--azure--400, #157E9D)",
        },
    },
    {
        name: "color--charts--colorful--10--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--700, #0D3491)",
            "ursa-dark": "var(--smar--com--color--blue--400, #3A6FE9)",
            "lodestar-light": "var(--smar--com--color--blue--700, #0D3491)",
        },
    },
    {
        name: "color--charts--colorful--10--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--700, #0D3491)",
            "ursa-dark": "var(--smar--com--color--blue--300, #6692FA)",
            "lodestar-light": "var(--smar--com--color--blue--700, #0D3491)",
        },
    },
    {
        name: "color--charts--semantic-not-started--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--neutral--300, #878DAB)",
            "ursa-dark": "var(--smar--com--color--neutral--200, #A6ACC4)",
            "lodestar-light": "var(--smar--com--color--neutral--300, #878DAB)",
        },
    },
    {
        name: "color--charts--semantic-not-started--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--neutral--400, #6B7394)",
            "ursa-dark": "var(--smar--com--color--neutral--100, #B8BDD1)",
            "lodestar-light": "var(--smar--com--color--neutral--400, #6B7394)",
        },
    },
    {
        name: "color--charts--semantic-in-progress--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--400, #3A6FE9)",
            "ursa-dark": "var(--smar--com--color--blue--200, #80A6FF)",
            "lodestar-light": "var(--smar--com--color--blue--400, #3A6FE9)",
        },
    },
    {
        name: "color--charts--semantic-in-progress--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--100, #9EBBFF)",
            "lodestar-light": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "color--charts--semantic-at-risk--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--yellow--100, #EFB32A)",
            "ursa-dark": "var(--smar--com--color--yellow--100, #EFB32A)",
            "lodestar-light": "var(--smar--com--color--yellow--100, #EFB32A)",
        },
    },
    {
        name: "color--charts--semantic-at-risk--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--yellow--200, #DEA41B)",
            "ursa-dark": "var(--smar--com--color--yellow--75, #F9CD67)",
            "lodestar-light": "var(--smar--com--color--yellow--200, #DEA41B)",
        },
    },
    {
        name: "color--charts--semantic-completed--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--300, #29AE40)",
            "ursa-dark": "var(--smar--com--color--green--200, #32C84C)",
            "lodestar-light": "var(--smar--com--color--green--300, #29AE40)",
        },
    },
    {
        name: "color--charts--semantic-completed--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--400, #1D862F)",
            "ursa-dark": "var(--smar--com--color--green--100, #62D574)",
            "lodestar-light": "var(--smar--com--color--green--400, #1D862F)",
        },
    },
    {
        name: "color--charts--semantic-blocked--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--red--300, #E96D75)",
            "ursa-dark": "var(--smar--com--color--red--200, #F29298)",
            "lodestar-light": "var(--smar--com--color--red--300, #E96D75)",
        },
    },
    {
        name: "color--charts--semantic-blocked--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--red--400, #DF2A36)",
            "ursa-dark": "var(--smar--com--color--red--100, #F7ABB0)",
            "lodestar-light": "var(--smar--com--color--red--400, #DF2A36)",
        },
    },
    {
        name: "color--background--notifications--strong",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--500, #B84028)",
            "ursa-dark": "var(--smar--com--color--orange--500, #B84028)",
            "lodestar-light": "var(--smar--com--color--orange--500, #B84028)",
        },
    },
    {
        name: "color--background--notifications--primary",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--500, #2D60D7)",
            "ursa-dark": "var(--smar--com--color--blue--500, #2D60D7)",
            "lodestar-light": "var(--smar--com--color--blue--500, #2D60D7)",
        },
    },
    {
        name: "color--charts--assets-dashboard--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--300, #29AE40)",
            "ursa-dark": "var(--smar--com--color--green--300, #29AE40)",
            "lodestar-light": "var(--smar--com--color--green--300, #29AE40)",
        },
    },
    {
        name: "color--charts--assets-dashboard--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--400, #1D862F)",
            "ursa-dark": "var(--smar--com--color--green--400, #1D862F)",
            "lodestar-light": "var(--smar--com--color--green--400, #1D862F)",
        },
    },
    {
        name: "color--charts--assets-workspace--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--azure--300, #1EA0C8)",
            "ursa-dark": "var(--smar--com--color--azure--300, #1EA0C8)",
            "lodestar-light": "var(--smar--com--color--azure--300, #1EA0C8)",
        },
    },
    {
        name: "color--charts--assets-workspace--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--azure--400, #157E9D)",
            "ursa-dark": "var(--smar--com--color--azure--400, #157E9D)",
            "lodestar-light": "var(--smar--com--color--azure--400, #157E9D)",
        },
    },
    {
        name: "color--charts--assets-sheet--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--violet--400, #8959E8)",
            "ursa-dark": "var(--smar--com--color--violet--400, #8959E8)",
            "lodestar-light": "var(--smar--com--color--violet--400, #8959E8)",
        },
    },
    {
        name: "color--charts--assets-sheet--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--violet--500, #7847DC)",
            "ursa-dark": "var(--smar--com--color--violet--500, #7847DC)",
            "lodestar-light": "var(--smar--com--color--violet--500, #7847DC)",
        },
    },
    {
        name: "color--charts--assets-report--rest",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--300, #F06B51)",
            "ursa-dark": "var(--smar--com--color--orange--300, #F06B51)",
            "lodestar-light": "var(--smar--com--color--orange--300, #F06B51)",
        },
    },
    {
        name: "color--charts--assets-report--hover",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--400, #D64529)",
            "ursa-dark": "var(--smar--com--color--orange--400, #D64529)",
            "lodestar-light": "var(--smar--com--color--orange--400, #D64529)",
        },
    },
    {
        name: "color--icons--assets-workspace--stroke",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--azure--600, #0B5C75)",
            "ursa-dark": "var(--smar--com--color--azure--600, #0B5C75)",
            "lodestar-light": "var(--smar--com--color--azure--600, #0B5C75)",
        },
    },
    {
        name: "color--icons--assets-workspace--fill",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--azure--75, #98DCF1)",
            "ursa-dark": "var(--smar--com--color--azure--75, #98DCF1)",
            "lodestar-light": "var(--smar--com--color--azure--75, #98DCF1)",
        },
    },
    {
        name: "color--icons--assets-portfolio--stroke",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--teal--600, #0F6151)",
            "ursa-dark": "var(--smar--com--color--teal--600, #0F6151)",
            "lodestar-light": "var(--smar--com--color--teal--600, #0F6151)",
        },
    },
    {
        name: "color--icons--assets-portfolio--fill",
        description: "",
        value: { "ursa-light": "#86E4D1", "ursa-dark": "#86E4D1", "lodestar-light": "#86E4D1" },
    },
    {
        name: "color--icons--assets-dashboard--stroke",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--500, #177827)",
            "ursa-dark": "var(--smar--com--color--green--500, #177827)",
            "lodestar-light": "var(--smar--com--color--green--500, #177827)",
        },
    },
    {
        name: "color--icons--assets-dashboard--fill",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--green--75, #8EE69D)",
            "ursa-dark": "var(--smar--com--color--green--75, #8EE69D)",
            "lodestar-light": "var(--smar--com--color--green--75, #8EE69D)",
        },
    },
    {
        name: "color--icons--assets-reports--stroke",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--500, #B84028)",
            "ursa-dark": "var(--smar--com--color--orange--500, #B84028)",
            "lodestar-light": "var(--smar--com--color--orange--500, #B84028)",
        },
    },
    {
        name: "color--icons--assets-reports--fill",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orange--75, #FEC8BE)",
            "ursa-dark": "var(--smar--com--color--orange--75, #FEC8BE)",
            "lodestar-light": "var(--smar--com--color--orange--75, #FEC8BE)",
        },
    },
    {
        name: "color--icons--assets-sheet--stroke",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--violet--600, #6329D6)",
            "ursa-dark": "var(--smar--com--color--violet--600, #6329D6)",
            "lodestar-light": "var(--smar--com--color--violet--600, #6329D6)",
        },
    },
    {
        name: "color--icons--assets-sheet--fill",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--violet--75, #D6C2FF)",
            "ursa-dark": "var(--smar--com--color--violet--75, #D6C2FF)",
            "lodestar-light": "var(--smar--com--color--violet--75, #D6C2FF)",
        },
    },
    {
        name: "color--icons--assets-form--stroke",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orchid--500, #A531B9)",
            "ursa-dark": "var(--smar--com--color--orchid--500, #A531B9)",
            "lodestar-light": "var(--smar--com--color--orchid--500, #A531B9)",
        },
    },
    {
        name: "color--icons--assets-form--fill",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--orchid--75, #F0C3F8)",
            "ursa-dark": "var(--smar--com--color--orchid--75, #F0C3F8)",
            "lodestar-light": "var(--smar--com--color--orchid--75, #F0C3F8)",
        },
    },
    {
        name: "color--icons--assets-collection--stroke",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--yellow--500, #88620C)",
            "ursa-dark": "var(--smar--com--color--yellow--500, #88620C)",
            "lodestar-light": "var(--smar--com--color--yellow--500, #88620C)",
        },
    },
    {
        name: "color--icons--assets-collection--fill",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--yellow--75, #F9CD67)",
            "ursa-dark": "var(--smar--com--color--yellow--75, #F9CD67)",
            "lodestar-light": "var(--smar--com--color--yellow--75, #F9CD67)",
        },
    },
    {
        name: "color--icons--assets-workapp--stroke",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--600, #184BC3)",
            "ursa-dark": "var(--smar--com--color--blue--600, #184BC3)",
            "lodestar-light": "var(--smar--com--color--blue--600, #184BC3)",
        },
    },
    {
        name: "color--icons--assets-workapp--fill",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--blue--75, #B8CDFF)",
            "ursa-dark": "var(--smar--com--color--blue--75, #B8CDFF)",
            "lodestar-light": "var(--smar--com--color--blue--75, #B8CDFF)",
        },
    },
    {
        name: "color--icons--assets-blueprint--stroke",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--aqua--600, #0F6151)",
            "ursa-dark": "var(--smar--com--color--aqua--600, #0F6151)",
            "lodestar-light": "var(--smar--com--color--aqua--600, #0F6151)",
        },
    },
    {
        name: "color--icons--assets-blueprint--fill",
        description: "",
        value: {
            "ursa-light": "var(--smar--com--color--aqua--75, #86E4D1)",
            "ursa-dark": "var(--smar--com--color--aqua--75, #86E4D1)",
            "lodestar-light": "var(--smar--com--color--aqua--75, #86E4D1)",
        },
    },
] as const;
